import { Autocomplete, Box, Button, Checkbox, Chip, Divider, FormControlLabel, Grid, IconButton, MenuItem, Modal, Radio, Select, SelectChangeEvent, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, ToggleButton, ToggleButtonGroup, tableCellClasses } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { FC, useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import CustomTextField from "../FormFields/CustomTextField";
// import CustomThemeTextField from "../FormFields/CustomThemeTextField";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from 'moment';
import * as yup from "yup";

import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';

import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFileTwoTone';
import RemoveRedEyeTwoToneIcon from '@mui/icons-material/RemoveRedEyeTwoTone';
import { RadioProps } from '@mui/material/Radio';
import { styled } from '@mui/material/styles';
import DialogClientForm from '../Dialog/CreateClientForm';
import { StyledInput } from '../Dialog/Dialog.styles';
import Client from './client.png';

// app utils

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { ApiStatus } from "../../utils/api.types";
import { IOptions } from "../FormFields/CustomSelect";

// app imports
import { EmployeeDependent, EmployeeEducation, EmployeeEmergencyContacts, EmployeeFormInputs, EmployeeSalary, PreviousEmployer } from '../../utils/employee.types';
// import { addInventory, fetchInventoryById, updateInventory, fetchItemCategories, fetchItemSubCategories, fetchMeasuringUnits } from '../../store/employeeStore/employeeThunk';
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import { addEmployee, fetchEmployeeById, fetchEmployeeSeqNumber, updateEmployee, fetchEmployees } from '../../store/employeeStore/employeeThunk';
import { fetchCurrencies } from '../../store/currencyStore/currencyThunk';
import { fetchAddresses } from '../../store/addressStore/addressThunk';


import { ListItemText } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Theme, useTheme } from '@mui/material/styles';
import * as React from 'react';
import axios from '../../utils/axios';
import { fetchAccountsByName, fetchCounterPartyAccountById } from '../../store/accountThunk';
// import PreviousEmployer from './PreviousEmployer';
import styled_ from "@emotion/styled";
import { toast } from 'react-toastify';
import { addDoc, deleteDoc } from '../../store/docAttachThunk';
import { TabPanel } from '../Dialog/TabPanel';
import Address from "../Dialog/ClientAgent/Address";


const StyledTableCell = styled_(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#fff',
    color: '#9da7b7',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    margin: 0,
    padding: 5,
    fontSize: 13,
    paddingLeft: '15px !important',
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: 14,
    fontWeight: 'normal',
    color: '#292d35',
    padding: 5,
    border: 'none',
    paddingLeft: '15px !important',
    margin: 0
  },
}));

const StyledTableRow = styled_(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fbfbfb',
    // border: '0.5px dashed #9da7b7',
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#e9ecf1',
    // border: '0.5px dashed #9da7b7',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
  },
}));

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: '0ms',
  width: 425,
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
};

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    width: '108%',
    boxShadow: 'none',
    marginLeft: '-6px',
    borderRadius: 7
  }
});
const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 0 1px rgb(16 22 26 / 40%)'
      : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

const BpIcon2 = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 15,
  height: 15,
  boxShadow:
    //   theme.palette.mode === 'dark'
    // ? '0 0 0 1px rgb(16 22 26 / 40%) ' :
    'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor:
    // theme.palette.mode === 'dark' ? '#394b59' : 
    '#f5f8fa',
  backgroundImage:
    //   theme.palette.mode === 'dark'
    // ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))' :
    'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor:
      //   theme.palette.mode === 'dark' ? '#30404d' : 
      '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      // theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 
      'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon2 = styled(BpIcon2)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 15,
    height: 15,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

// Inspired by blueprintjs
function BpRadio(props: RadioProps) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
    <Tabs
      {...props}
    />
  ))({
    backgroundColor: '#fafafaff',
    borderRadius: '12px',
    marginLeft: '10px',
    padding: '6px',
    minHeight: '48px',
    maxWidth: 'fit-content',
    '& .MuiTabs-flexContainer': {
      gap: '4px',
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
      color: '#a0aec0',
      zIndex: 2,
      minWidth: 'auto',
      height: '36px',
      minHeight: '36px',
      padding: '8px 20px',
      borderRadius: '8px',
      transition: 'all 0.2s ease-in-out',
      '&:hover:not(.Mui-selected)': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: '#059669',
      },
      '&.Mui-selected': {
        backgroundColor: '#059669',
        color: '#ffffff',
        fontWeight: 600,
        boxShadow: '0 2px 8px rgba(5, 150, 105, 0.3)',
      },
    },
  });

interface TabPanelProps {
  index: number;
  value: number;
}

const StyledTabPanel = styled((props: TabPanelProps) => (
  <TabPanel
    {...props}
  />
))({
  '& .MuiBox-root': {
    backgroundColor: 'transparent !important',
    padding: '0px !important',
  }
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: '#545454',
  '&.Mui-selected': {
    color: '#059669',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(100, 95, 228, 0.32)',
  },
}));

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

// Schema to validate inventory form.
const schema = yup.object().shape({
  name: yup.string().required("Employee Name is required"),
  empId: yup.string().required("Employee Id is required"),
  dob: yup.string().required("DOB is required"),
  dateOfJoining: yup.string().required("Date Of Joining is required"),
  personalEmail: yup.string().email("Invalid Email").required("Please enter email"),
  primaryPhone: yup.string().max(10, 'Primary Phone must be at most 10 characters').matches(phoneRegExp, 'Phone number is not valid'),
  billingAddressCountry: yup.string().required("Country is required."),
  billingAddressState: yup.string().required("State is required."),
  billingAddressCity: yup.string().required("City is required."),
  shippingAddressCountry: yup.string().required("Country is required."),
  shippingAddressState: yup.string().required("State is required."),
  shippingAddressCity: yup.string().required("City is required."),
  fatherName: yup.string().optional(),
  motherName: yup.string().optional(),
  // baseLocation is validated conditionally in onSubmit - required only when worksForSelf is false

  // primaryPhone: yup.string().
  // primaryPhone: yup.string().max(10, 'Primary Phone must be at most 10 characters').required("Primary Phone is required"),
  // isMarried: yup.string().required("Select Marrital Status"),
  // baseLocation: yup.string().required("Select work location"),
  // personalEmail: yup.string().required("Personal Email is required"),
});

interface EmployeeFormProps {
  type?: string;
  model?: boolean;
  onClose?: () => void;
}

interface EmergencyContacts {
  name?: string;
  phone?: string;
  relation?: string;
  data: any[]
}

interface Dependents {
  full_name?: string;
  phone?: string;
  relation?: string;
  dob?: Date;
  data: any[]
}

interface Education {
  college?: string;
  university?: string;
  education?: string;
  course?: string;
  start_date?: Date;
  end_date?: Date;
  passing_year?: string;
  percentage?: string;
  data: any[]
}

interface PreEmployer {
  name?: string;
  title?: string;
  gross_salary?: string;
  ctc?: string;
  start_date?: Date;
  end_date?: Date;
  data: any[]
}

interface DoucumentProps {
  name: string;
  document: any
}

// Estimate component. 
const EmployeeForm: FC<EmployeeFormProps> = ({ type, model, onClose }) => {
  const { pathname } = useLocation();
  const { employeeId } = useParams();

  const [document, setDocument] = useState<DoucumentProps>();
  const [documentModel, setDocumentModel] = useState(false);

  const isEditing = employeeId ? true : false;

  const [value, setValue] = useState(0);
  const [emergencyContacts, setEmergencyContacts] = useState<EmergencyContacts>({
    name: '',
    phone: '',
    relation: '',
    data: []
  });

  const [dependentsContacts, setDependentsContacts] = useState<Dependents>({
    full_name: '',
    phone: '',
    relation: '',
    dob: undefined,
    data: []
  });

  const [education, setEducation] = useState<Education>({
    college: '',
    university: "",
    education: '',
    course: '',
    start_date: undefined,
    end_date: undefined,
    passing_year: undefined,
    percentage: '',
    data: []
  });

  const [preEmpolyer, setPreEmployer] = useState<PreEmployer>({
    name: '',
    title: "",
    gross_salary: '',
    ctc: '',
    start_date: undefined,
    end_date: undefined,
    data: []
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // use form
  const methods = useForm<EmployeeFormInputs>({
    resolver: yupResolver(schema),
  });

  const formRef = useRef<any>();
  const classes = useStyles();

  // States
  const { status } = useAppSelector(state => state.employees);
  const employeeDetails = useAppSelector(state => state.employees.employeeDetails);
  const { selectedAccount } = useAppSelector(state => state.auth);
  const { docs } = useAppSelector(state => state.docAttach);

  const [images, setImages] = useState<File[]>([]);

  // Form and component loader states
  const [isLoading, setIsLoading] = useState(false);
  const [isformLoaded, setIsFormLoaded] = useState(false);

  // for Update Employee
  const [newEmployeeId, setNewEmployeeId] = useState('');

  // Family Relation fields
  const [familyRelationOptions, setFamilyRelationOptions] = useState<IOptions[]>([]);
  const [selectedTaxRateValue, setSelectedTaxRateValue] = useState(""); // currently used for other relations types
  const [selectedNomineeRelation, setSelectedNomineeRelation] = useState("");

  // Client fields
  const [open, setOpen] = useState<Array<boolean>>([false, false, false, false]);
  const [isClientLoading, setIsClientLoading] = useState(false);
  const [isBuyerLoading, setIsBuyerLoading] = useState(false);

  const [selectedOption, setSelectedOption] = useState(""); // set the client id
  const [options, setOptions] = useState<any[]>([]); // fetch all clients
  const [selected, setSelected] = useState<any>(); // set key, value data for client
  const [newOption, setNewOption] = useState("");
  const [closedSelect, setClosedSelect] = useState(false);

  // set options for selected client
  const [worksForSelf, setWorksForSelf] = useState(false);
  const [selectedClient, setSelectedClient] = useState<any>();
  const [selectedClientAddreesOptions, setSelectedClientAddreesOptions] = useState<any[]>([]); // form all client address in options
  const [baseLocation, setBaseLocation] = useState("");
  const [selectedWorkLocation, setSelectedWorkLocation] = useState<string>("");
  const [adminAddresses, setAdminAddresses] = useState<any[]>([]);

  const [selectedIndex, setSelectedIndex] = useState(1);
  const [selectBuyer, setSelectBuyer] = useState(false);
  const [dobDate, setDobDate] = useState<Date>();
  const [addChecked, setAddChecked] = useState(false);
  const [isMarried, setIsMarried] = useState(false);
  const [isPrevEmployment, setIsPrevEmployment] = useState(false);
  const [isCompliance, setIsCompliance] = useState(false);

  const [dateOfJoining, setDateOfJoining] = useState<Date>();
  const [dateofResign, setDateofResign] = useState<Date>();
  const [reportingTo, setReportingTo] = useState('');
  const [managerOptions, setManagerOptions] = useState<any[]>([]);
  const managerSearchTimer = useRef<any>(null);

  // Bank account details
  const [currencyOptions, setCurrencyOptions] = useState<IOptions[]>([]);
  const [bankCurrency, setBankCurrency] = useState('');

  const [selectedFamilyRealtion, setSelectedFamilyRelation] = useState([]);

  // Emergeency Phones
  const [emergencyPhones, setEmergencyPhones] = useState<EmployeeEmergencyContacts[]>([]);
  // Employee Dependents Details
  const [dependentModal, setDependentModal] = useState(false);
  const [dependents, setDependents] = useState<EmployeeDependent[]>([]);
  const [selectedDependent, setSelectedDependent] = useState<EmployeeDependent>();
  const [selectedDependentIndex, setSelectedDependentIndex] = useState<any>();
  const [editDepenedent, setEditDependent] = useState(false);

  // Employee Education Details
  const [empEducationModal, setEmpEducationModal] = useState(false);
  const [empEducationDetails, setEmpEducationDetails] = useState<EmployeeEducation[]>([]);
  const [selectedEmpEducation, setSelectedEmpEducation] = useState<EmployeeEducation>();
  const [selectedEmpEducationIndex, setSelectedEmpEducationIndex] = useState<any>();
  const [editEmpEducation, setEditEmpEducation] = useState(false);

  // Employee Prev Employer Details
  const [prevEmployerModal, setPrevEmployerModal] = useState(false);
  const [prevEmployerDetails, setPrevEmployerDetails] = useState<PreviousEmployer[]>([]);
  const [selectedPrevEmployer, setSelectedPrevEmployer] = useState<PreviousEmployer>();
  const [selectedPrevEmployerIndex, setSelectedPrevEmployerIndex] = useState<any>();
  const [editPrevEmployer, setEditPrevEmployer] = useState(false);

  // handle media files states
  const [profileImage, setProfileImage] = useState("");
  const [selectedProfileFile, setSelectedProfileFile] = useState<File | null>(null);

  const [signatureImage, setSignatureImage] = useState("");
  const [selectedSignatureFile, setSelectedSignatureFile] = useState<File | null>(null);

  const [termsAndConditionPhoto, setTermsAndConditionPhoto] = useState<File | null>(null);
  const [termsAndConditionThumbnail, setTermsAndConditionThumbnail] = useState<any>(null);

  const [bgvConsentFile, setBgvConsentFile] = useState<File | null>(null);
  const [bgvConsentPreview, setBgvConsentPreview] = useState<any>(null);

  const [thumbFile, setThumbFile] = useState<File | null>(null);
  const [thumbPreview, setThumbPreview] = useState<any>(null);

  const [aadharFile, setAadharFile] = useState<File | null>(null);
  const [aadharPreview, setAadharPreview] = useState<any>(null);

  const [panCardFile, setPanCardFile] = useState<File | null>(null);
  const [panCardPreview, setPanCardPreview] = useState<any>(null);

  const [passbookFile, setPassbookFile] = useState<File | null>(null);
  const [passbookPreview, setPassbookPreview] = useState<any>(null);

  const [pvcFile, setPvcFile] = useState<File | null>(null);
  const [pvcPreview, setPvcPreview] = useState<any>(null);

  const [bvcFile, setBvcFile] = useState<File | null>(null);
  const [bvcPreview, setBvcPreview] = useState<any>(null);

  const [attachments, setAttachments] = useState<String[]>([]);
  const [deleteDocs, setDeleteDocs] = useState<String[]>([]);

  const [employeeSeqData, setEmployeeSeqData] = useState<any>();

  const [docData, setDocData] = useState<any[]>([]);
  const [fetchData, setFetchData] = useState('');

  // Employee Salary Details
  const [empSalary, setEmpSalary] = useState<EmployeeSalary>();

  const theme = useTheme();
  const [language, setLanguage] = React.useState<string[]>([]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const languageNames = ['Hindi', 'English', 'Marathi', 'Kannada', 'Telugu', 'Malayalam', 'Gujarati', 'Punjabi'];

  function getStyles(name: string, language: readonly string[], theme: Theme) {
    return {
      fontWeight:
        language.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const handleLangaugeChange = (event: SelectChangeEvent<typeof language>) => {
    const {
      target: { value },
    } = event;
    setLanguage(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const openCloseDrawer = (label: string) => {
    let openArray = [...open]
    if (label === 'document') {
      openArray[0] = !openArray[0];
    } else {
      openArray[3] = !openArray[3];
      setIsClientLoading(true);
    }
    setOpen(openArray);
  }

  const closeDialog = (isSaved: boolean) => {
    let openArray = [...open]
    openArray.forEach((x, i) => openArray[i] = false);
    setOpen(openArray);

    if (isSaved) {
      setFetchData(Math.random().toString());
    }
  }

  const cancelDialog = () => {
    setIsClientLoading(false); setIsLoading(false);
  }









  const dispatch = useAppDispatch();
  const navigate = useNavigate();


  const handleListItemClick = (index: number) => {
    setSelectedIndex(index);
  };

  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      if (name === 'dob') {
        setDobDate(newValue);
        methods.setValue("dob", newValue.toString(), { shouldValidate: true });
      }
      else if (name === 'dateOfJoining') {
        setDateOfJoining(newValue);
        methods.setValue("dateOfJoining", newValue.toString(), { shouldValidate: true });
      }
      else if (name === 'dateofResign')
        setDateofResign(newValue);
      else if (name === 'dependent')
        setDependentsContacts({ ...dependentsContacts, dob: newValue });
      else if (name === 'education start_date')
        setEducation({ ...education, start_date: newValue });
      else if (name === 'education end_date')
        setEducation({ ...education, end_date: newValue });
      // else if (name === 'education passing_year')
      //   setEducation({ ...education, passing_year : newValue});
      else if (name === 'preEmpolyer start_date')
        setPreEmployer({ ...preEmpolyer, start_date: newValue });
      else if (name === 'preEmpolyer end_date')
        setPreEmployer({ ...preEmpolyer, end_date: newValue });
    }
  };

  // Populate Static options for employee.
  useEffect(() => {
    let familyRelation = [
      { label: "Father", value: "Father" },
      { label: "Mother", value: "Mother" },
      { label: "Son", value: "Son" },
      { label: "Daughter", value: "Daughter" },
      { label: "Husband", value: "Husband" },
      { label: "Wife", value: "Wife" },
      { label: "Brother", value: "Brother" },
      { label: "Sister", value: "Sister" },
      { label: "Grandfather", value: "Grandfather" },
      { label: "Grandmother", value: "Grandmother" },
      { label: "Grandson", value: "Grandson" },
      { label: "Uncle", value: "Uncle" },
      { label: "Aunt", value: "Aunt" },
      { label: "Nephew", value: "Nephew" },
      { label: "Niece", value: "Niece" },
      { label: "Cousins", value: "Cousins" },
      { label: 'Other', value: 'Other' },
    ];
    setFamilyRelationOptions(familyRelation);

    // Fetch currencies for bank account
    getCurrencies();
  }, []);

  const getCurrencies = async () => {
    if (!currencyOptions.length) {
      const data: any = await dispatch(fetchCurrencies());
      if (data.payload) {
        const options = data.payload.map((c: any) => {
          return { label: c.code, value: c._id }
        });
        setCurrencyOptions(options);

        // Set first currency (INR) as default if no currency is selected
        if (options.length > 0 && !bankCurrency) {
          setBankCurrency(options[0].value);
          methods.setValue("bankCurrency", options[0].value);
        }
      }
    }
  };

  const selectedClientHandler = (data: any) => {
    setSelectedClient(data);
  };

  //Method to handle invoice form submit.
  const onSubmit = async (data: EmployeeFormInputs) => {
    console.log("onSubmit Called ======== ");

    if (data) {
      data.account = selectedAccount._id;
      if (dobDate) { data.dob = dobDate.toString(); }
      if (dateOfJoining) { data.dateOfJoining = dateOfJoining.toString(); } else { delete data.dateOfJoining; }
      if (dateofResign) { data.dateofResign = dateofResign.toString(); } else { delete data.dateofResign; }
      if (data.marriageDate) { data.marriageDate = data.marriageDate.toString(); } else { delete data.marriageDate; }
      data.isMarried = isMarried === true ? true : false;
      data.isPrevEmployment = isPrevEmployment === true ? true : false;
      data.isCompliance = isCompliance === true ? true : false;
      data.worksForSelf = worksForSelf;
      data.client = selectedClient ? selectedClient._id : '';
      if (selectedWorkLocation && selectedWorkLocation.startsWith('address:')) {
        data.workLocationAddress = selectedWorkLocation.slice('address:'.length);
        data.workLocationLabel = '';
      } else if (selectedWorkLocation && selectedWorkLocation.startsWith('business:')) {
        data.workLocationAddress = null;
        data.workLocationLabel = selectedWorkLocation.slice('business:'.length);
      } else {
        data.workLocationAddress = null;
        data.workLocationLabel = '';
      }
      data.gender = gender;
      if (reportingTo) { data.reportingTo = reportingTo; }

      // set educationd
      if (emergencyContacts.data && emergencyContacts.data.length > 0) {
        data.emergencyPhones = emergencyContacts.data;
      } else {
        data.emergencyPhones = [];
      }
      if (dependentsContacts.data && dependentsContacts.data.length > 0) {
        data.dependents = dependentsContacts.data;
      } else {
        data.dependents = [];
      }
      if (education.data && education.data.length > 0) {
        data.education = education.data;
      } else {
        data.education = [];
      }
      if (preEmpolyer.data && preEmpolyer.data.length > 0) {
        data.prevEmployment = preEmpolyer.data;
      } else {
        data.prevEmployment = [];
      }
      data.salary = [{
        grossSalary: data.grossSalary,
        ctc: data.ctc,
        assessmentYear: data.assessmentYear,
        startDate: dateOfJoining ? dateOfJoining.toString() : null,
        endDate: null,
        active: true
      }]
    }

    // const docsIds = docData.map(({ _id }) => _id);
    // data.attachments = docsIds;

    console.log("final form data ===> ", data);

    let formData = getFormData(data);

    if (selectedProfileFile) {
      formData.append('photo', selectedProfileFile);
    }
    // if (selectedAadharCard) {
    //   formData.append('aadhar', selectedAadharCard);
    // }
    // if (selectedPanCard) {
    //   formData.append('tinPan', selectedPanCard);
    // }
    // if (selectedPassbook) {
    //   formData.append('passbook', selectedPassbook);
    // }
    // if (selectedpvc) {
    //   formData.append('pvc', selectedpvc);
    // }
    // if (selectedbvc) {
    //   formData.append('bvc', selectedbvc);
    // }
    if (selectedSignatureFile) {
      formData.append('signature', selectedSignatureFile);
    }
    await DeleteDocs(deleteDocs);
    const fileData = await UploadAllFiles();
    const AllAttachments = attachments.concat(fileData)
    if (AllAttachments.length > 0) formData.append('attachments', JSON.stringify(AllAttachments));

    try {
      if (!isEditing) {
        await dispatch(addEmployee(formData)).unwrap().then(async (data) => {
          if (data && data.employee) {
            let newEmployeeId = data.employee._id;
            if (newEmployeeId) {
              setNewEmployeeId(newEmployeeId);
              // Navigate to view page after successful creation
              navigate(`/employee/view/${newEmployeeId}`);
            }
          }
        });
      } else {
        if (employeeId) {
          await dispatch(updateEmployee({ id: employeeId, employeePayload: formData })).unwrap().then((responseData) => {
            if (responseData.message) redirectToEmployeeView();
          });
          setNewEmployeeId(employeeId)
        }
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const getFormData = (object: any) => {
    var newform = new FormData();
    Object.keys(object).forEach(key => {
      if (Array.isArray(object[key])) {
        newform.append(key, JSON.stringify(object[key]));
      } else {
        newform.append(key, object[key]);
      }
    });
    return newform;
  };

  // Method to handle Cancel button click.
  const onCancel = () => {
    methods.reset();
    const cancelLink = `/employee`;
    navigate(cancelLink);
  };

  // Method to handle Cancel button click.
  const redirectToEmployeeView = () => {
    if (employeeId) {
      methods.reset();
      const cancelLink = `/employee/view/${employeeId}`;
      navigate(cancelLink);
    }
  };


  // fetch current employee details on edit
  useEffect(() => {
    if (employeeId) {
      dispatch(fetchEmployeeById(employeeId));
    }
  }, [employeeId, dispatch]);

  useEffect(() => {
    console.log("===> use effect11 called for navigateToViewEmployee, newEmployeeId ==>", newEmployeeId);
    const navigateToViewEmployee = async () => {
      console.log("navigateToViewEmployee called ", newEmployeeId)
      // Only navigate if newEmployeeId is set AND we are NOT editing (creating new employee)
      if (newEmployeeId && !isEditing) {
        navigate(`/employee/view/${newEmployeeId}`);
      }
    }
    // Redirect to view page after employee creation
    navigateToViewEmployee();

  }, [newEmployeeId, isEditing])

  const getInvoiceDetails = async () => {
    await dispatch(fetchEmployeeSeqNumber(`${'Employee'}`)).then(async (data: any) => {
      if (data.payload) {
        setIsFormLoaded(true);
        setIsLoading(true);
        setEmployeeSeqData(data.payload);
      } else
        methods.trigger("empId");
    }).catch(e => {
      // console.log(e);
    });
  };

  // Fetch managers list for Reporting To dropdown
  const fetchManagerOptions = async (search?: string) => {
    const { _id: id } = selectedAccount;
    const filterParam = search ? `&filter=${search}` : '';
    const data: any = await dispatch(fetchEmployees({ accountId: id, type: 'employee', params: `&limit=100${filterParam}` }));
    if (data.payload?.employees) {
      const options = data.payload.employees
        .filter((emp: any) => emp._id !== employeeId) // exclude self
        .map((emp: any) => ({
          label: `${emp.name} (${emp.empId})`,
          value: emp._id
        }));
      setManagerOptions(options);
    }
  };

  useEffect(() => {
    fetchManagerOptions();
  }, [dispatch, selectedAccount]);

  useEffect(() => {
    const accId = selectedAccount?._id;
    if (!accId) return;
    dispatch(fetchAddresses(accId)).unwrap()
      .then((res: any) => {
        const list = res?.addresses || res?.data || res || [];
        setAdminAddresses(Array.isArray(list) ? list : []);
      })
      .catch(() => setAdminAddresses([]));
  }, [dispatch, selectedAccount]);

  // Fetch last employee seq number and employee details.
  useEffect(() => {
    if (!isEditing)
      getInvoiceDetails();
  }, [isEditing]);

  useEffect(() => {
    if (employeeSeqData) {
      if (!isEditing) {
        methods.setValue("empId", employeeSeqData.employeeNumber);
        setIsLoading(false)
      }
      setTimeout(() => setIsFormLoaded(false), 1000);
    }
  }, [employeeSeqData])

  useEffect(() => {
    if (employeeDetails && isEditing) {
      setSelected(employeeDetails);
    }
  }, [employeeDetails, isEditing])


  //Set edit estimate data in case of edit.
  useEffect(() => {
    const setInitialData = async () => {
      console.log(isEditing);
      try {
        if (employeeDetails && isEditing) {
          setIsFormLoaded(true);
          setIsLoading(true);

          methods.setValue('empId', employeeDetails.empId);
          // Only set client if it exists (not null for worksForSelf employees)
          if (employeeDetails.client && employeeDetails.client._id) {
            methods.setValue('client', employeeDetails.client._id);
          }
          methods.setValue("name", employeeDetails.name);
          setGender(employeeDetails.gender);

          // set all media files
          setProfileImage(employeeDetails.photo);
          setSignatureImage(employeeDetails.signature);
          if (employeeDetails.attachments) {
            setAttachments(employeeDetails.attachments.map((e: any) => e._id));
            employeeDetails.attachments.map((file: any) => {
              if (file.fieldName) {
                if (file.fieldName === 'termsAndConditionPhoto') setTermsAndConditionThumbnail({ data: file.s3Data, name: file.originalname, id: file._id });
                if (file.fieldName === 'bgvConsentPhoto') setBgvConsentPreview({ data: file.s3Data, name: file.originalname, id: file._id });
                if (file.fieldName === 'thumbPhoto') setThumbPreview({ data: file.s3Data, name: file.originalname, id: file._id });
                if (file.fieldName === 'aadharCard') setAadharPreview({ data: file.s3Data, name: file.originalname, id: file._id });
                if (file.fieldName === 'pvc') setPvcPreview({ data: file.s3Data, name: file.originalname, id: file._id });
                if (file.fieldName === 'bvc') setBvcPreview({ data: file.s3Data, name: file.originalname, id: file._id });
                if (file.fieldName === 'panCard') setPanCardPreview({ data: file.s3Data, name: file.originalname, id: file._id });
                if (file.fieldName === 'passbook') setPassbookPreview({ data: file.s3Data, name: file.originalname, id: file._id });
              }
            })
          }

          // Handle worksForSelf field
          if (employeeDetails.worksForSelf) {
            setWorksForSelf(true);
          } else if (employeeDetails.client && employeeDetails.client._id) {
            let _selectedClient = await dispatch(fetchCounterPartyAccountById(employeeDetails.client._id));
            setSelectedClient(_selectedClient.payload);
            setSelectedOption(employeeDetails.client._id);
          }

          if (employeeDetails.baseLocation && employeeDetails.baseLocation._id) {
            methods.setValue("baseLocation", employeeDetails.baseLocation._id);
            setBaseLocation(employeeDetails.baseLocation._id);
          }
          if (employeeDetails.workLocation) {
            const wlId = typeof employeeDetails.workLocation === 'object'
              ? employeeDetails.workLocation._id
              : employeeDetails.workLocation;
            setSelectedWorkLocation(wlId || '');
          }

          if (employeeDetails.workLocationAddress) {
            const wlaId = typeof employeeDetails.workLocationAddress === 'object'
              ? employeeDetails.workLocationAddress._id
              : employeeDetails.workLocationAddress;
            if (wlaId) setSelectedWorkLocation(`address:${wlaId}`);
          } else if (employeeDetails.workLocationLabel) {
            setSelectedWorkLocation(`business:${employeeDetails.workLocationLabel}`);
          }

          if (employeeDetails.workLocationAddress) {
            const wlaId = typeof employeeDetails.workLocationAddress === 'object'
              ? employeeDetails.workLocationAddress._id
              : employeeDetails.workLocationAddress;
            if (wlaId) setSelectedWorkLocation(`address:${wlaId}`);
          } else if (employeeDetails.workLocationLabel) {
            setSelectedWorkLocation(`business:${employeeDetails.workLocationLabel}`);
          }

          methods.setValue("dob", employeeDetails.dob);
          setDobDate(employeeDetails.dob);

          methods.setValue("fatherName", employeeDetails.fatherName);
          methods.setValue("motherName", employeeDetails.motherName);
          methods.setValue("personalEmail", employeeDetails.personalEmail);
          methods.setValue("businessEmail", employeeDetails.businessEmail);
          methods.setValue("primaryPhone", employeeDetails.primaryPhone);
          methods.setValue("alternatePhone", employeeDetails.alternatePhone);
          methods.setValue("isAlternatePhoneVerified", employeeDetails.isAlternatePhoneVerified);
          methods.setValue("alternatePhoneRelation", employeeDetails.alternatePhoneRelation);

          methods.setValue("isMarried", employeeDetails.isMarried);
          methods.setValue("marriageDate", employeeDetails.marriageDate);
          setIsMarried(employeeDetails.isMarried);

          methods.setValue("spouseName", employeeDetails.spouseName);
          methods.setValue("spousePhone", employeeDetails.spousePhone);

          setDependents(employeeDetails.dependents || []);

          methods.setValue("presentAddress", employeeDetails.presentAddress);
          methods.setValue("permanentAddress", employeeDetails.permanentAddress);

          // Set address fields for validation
          if (Array.isArray(employeeDetails.addresses) && employeeDetails.addresses.length > 0) {
            const presentAddr = employeeDetails.addresses.find((addr: any) => addr.type === 'Present Address');
            const permanentAddr = employeeDetails.addresses.find((addr: any) => addr.type === 'Permanent Address');

            if (presentAddr) {
              methods.setValue("billingAddressCountry", presentAddr.country?._id || '');
              methods.setValue("billingAddressState", presentAddr.state?._id || '');
              methods.setValue("billingAddressCity", presentAddr.city || '');
              methods.setValue("billingAddressLine1", presentAddr.line1 || '');
              methods.setValue("billingAddressLine2", presentAddr.line2 || '');
              methods.setValue("billingAddressPinCode", presentAddr.code ? Number(presentAddr.code) : undefined);
            }

            if (permanentAddr) {
              methods.setValue("shippingAddressCountry", permanentAddr.country?._id || '');
              methods.setValue("shippingAddressState", permanentAddr.state?._id || '');
              methods.setValue("shippingAddressCity", permanentAddr.city || '');
              methods.setValue("shippingAddressLine1", permanentAddr.line1 || '');
              methods.setValue("shippingAddressLine2", permanentAddr.line2 || '');
              methods.setValue("shippingAddressPinCode", permanentAddr.code ? Number(permanentAddr.code) : undefined);
            }
          }

          setEmpEducationDetails(employeeDetails.education || []);

          methods.setValue("isPrevEmployment", employeeDetails.isPrevEmployment);
          setPrevEmployerDetails(employeeDetails.prevEmployment || []);

          methods.setValue("languages", employeeDetails.languages || []);
          setLanguage(employeeDetails.languages || []);

          setEmergencyContacts({ name: '', relation: '', phone: '', data: employeeDetails.emergencyPhones || [] });
          setEducation({ ...education, data: employeeDetails.education || [] });
          setDependentsContacts({ ...dependentsContacts, data: employeeDetails.dependents || [] });
          setPreEmployer({ ...preEmpolyer, data: employeeDetails.prevEmployment || [] });

          // Set salary details if available
          if (employeeDetails.salary && employeeDetails.salary.length > 0) {
            methods.setValue("grossSalary", employeeDetails.salary[0].grossSalary);
            methods.setValue("ctc", employeeDetails.salary[0].ctc);
            methods.setValue("assessmentYear", employeeDetails.salary[0].assessmentYear);
            methods.setValue("startDate", employeeDetails.salary[0].startDate);
            methods.setValue("endDate", employeeDetails.salary[0].endDate);
            methods.setValue("isActiveSalary", employeeDetails.salary[0].active);
          }

          methods.setValue("dateOfJoining", employeeDetails.dateOfJoining);
          methods.setValue("dateofResign", employeeDetails.dateofResign);
          setDateOfJoining(employeeDetails.dateOfJoining)
          setDateofResign(employeeDetails.dateofResign)
          methods.setValue("reasonOfResign", employeeDetails.reasonOfResign);

          // Set reporting to
          if (employeeDetails.reportingTo) {
            const managerId = employeeDetails.reportingTo._id || employeeDetails.reportingTo;
            setReportingTo(managerId);
            methods.setValue("reportingTo", managerId);
          }

          methods.setValue("isCompliance", employeeDetails.isCompliance);
          setIsCompliance(employeeDetails.isCompliance);
          methods.setValue("nomineeName", employeeDetails.nomineeName);
          methods.setValue("nomineeRelation", employeeDetails.nomineeRelation);
          methods.setValue("bankLinkPhone", employeeDetails.bankLinkPhone);
          setSelectedNomineeRelation(employeeDetails.nomineeRelation);
          setDocData(employeeDetails.attachments)

          // Set bank account details if available
          if (employeeDetails.bankAccounts && employeeDetails.bankAccounts.length > 0) {
            const bankAccount = employeeDetails.bankAccounts[0];
            methods.setValue("bankAccountId", bankAccount._id);
            methods.setValue("bankAccountName", bankAccount.accountName);
            methods.setValue("bankAccountNumber", bankAccount.accountNumber);
            methods.setValue("bankName", bankAccount.bankName);
            methods.setValue("bankBranchName", bankAccount.branchName);
            methods.setValue("bankIFSC", bankAccount.IFSC);
            methods.setValue("bankCurrency", bankAccount.currency?._id || bankAccount.currency);
            setBankCurrency(bankAccount.currency?._id || bankAccount.currency || '');
          }

          setIsLoading(false);
          setIsFormLoaded(false);
        }
      } catch (error: any) {
        console.error("setInitialData error:", error);
        toast.error("Error loading employee data. Please refresh the page.");
      }
    };

    if (Object.keys(employeeDetails).length > 0) setInitialData();
  }, [methods, dispatch, employeeDetails, isEditing, selectedAccount, type]);

  const onAddCheckHandler = (ischecked: boolean) => {
    let currentValues = methods.getValues();
    methods.setValue("permanentAddress", (ischecked) ? currentValues.presentAddress : '');
  }

  useEffect(() => {
    if (selectedClient) {
      const clientAddresses = selectedClient.addresses;
      if (clientAddresses.length > 0) {
        let addOption = [];
        addOption = clientAddresses.map((address: any) => {
          const _address = [address.line1, address.line2, address.city, address?.state?.name, address?.country?.name, address.code];
          const formatAddress = _address.filter(n => n).join(", ");
          const typeLabel = address.type ? `${address.type} - ` : '';
          return { label: `${typeLabel}${formatAddress}`, value: address._id }
        });
        setSelectedClientAddreesOptions(addOption)
        setIsClientLoading(false);
      }
    }

  }, [selectedClient])

  const onInputChangeHandler = async (event: React.SyntheticEvent, value: string) => {
    setSelected('')
    setSelectedOption('');
    // setNewOption(value);
    await dispatch(fetchAccountsByName(value)).unwrap().then((data) => {
      if (data) {
        setOptions(data.accounts);
      }
    });
  };

  const onCloseHandler = () => {
    setClosedSelect(true);
  };

  const onOpenHandler = () => {
    setClosedSelect(false);
  };

  useEffect(() => {
    if (selectedDependentIndex) {
      delete dependents[selectedDependentIndex];
      setSelectedDependent(undefined);
    }
    if (selectedEmpEducationIndex) {
      delete empEducationDetails[selectedEmpEducationIndex];
      setSelectedEmpEducationIndex(undefined);
    }

    if (selectedPrevEmployerIndex) {
      delete dependents[selectedPrevEmployerIndex];
      setSelectedPrevEmployerIndex(undefined);
    }

  }, [dependents, empEducationDetails])

  // Method to set preview of selected picture.
  const handleSelectProfileFile = (event: any) => {
    const target = event.target as HTMLInputElement;

    if (target.files && target.files[0]) {
      setSelectedProfileFile(target.files[0]);
      setProfileImage(URL.createObjectURL(target.files[0]));
    }
  };

  const handleDeleteRefFile = (type: any) => {
    if (type === 't&c') {
      if (termsAndConditionThumbnail?.id) {
        setAttachments(attachments.filter(e => e !== termsAndConditionThumbnail.id))
        setDeleteDocs([...deleteDocs, termsAndConditionThumbnail.id])
      }
    }
    else if (type === 'bgv') {
      if (bgvConsentPreview?.id) {
        setAttachments(attachments.filter(e => e !== bgvConsentPreview.id))
        setDeleteDocs([...deleteDocs, bgvConsentPreview.id])
      }
    }
    else if (type === 'thumb') {
      if (thumbPreview?.id) {
        setAttachments(attachments.filter(e => e !== thumbPreview.id))
        setDeleteDocs([...deleteDocs, thumbPreview.id])
      }
    }
    if (type === 'aadhar') {
      if (aadharPreview?.id) {
        setAttachments(attachments.filter(e => e !== aadharPreview.id))
        setDeleteDocs([...deleteDocs, aadharPreview.id])
      }
    }
    else if (type === 'pan') {
      if (panCardPreview?.id) {
        setAttachments(attachments.filter(e => e !== panCardPreview.id))
        setDeleteDocs([...deleteDocs, panCardPreview.id])
      }
    }
    else if (type === 'passbook') {
      if (passbookPreview?.id) {
        setAttachments(attachments.filter(e => e !== passbookPreview.id))
        setDeleteDocs([...deleteDocs, passbookPreview.id])
      }
    }
    else if (type === 'bvc') {
      if (bvcPreview?.id) {
        setAttachments(attachments.filter(e => e !== bvcPreview.id))
        setDeleteDocs([...deleteDocs, bvcPreview.id])
      }
    }
    else if (type === 'pvc') {
      if (pvcPreview?.id) {
        setAttachments(attachments.filter(e => e !== pvcPreview.id))
        setDeleteDocs([...deleteDocs, pvcPreview.id])
      }
    }
  };

  const pickFile = async (event: any, type: string) => {
    try {
      const target = event.target;
      if (target.files && target.files[0]) {
        const fileObj = {
          name: target.files[0].name,
          uri: URL.createObjectURL(target.files[0]),
          type: target.files[0].type,
          size: target.files[0].size
        }
        if (type === 't&c') {
          if (termsAndConditionThumbnail?.id) {
            setAttachments(attachments.filter(e => e !== termsAndConditionThumbnail.id))
            setDeleteDocs([...deleteDocs, termsAndConditionThumbnail.id])
          }
          setTermsAndConditionPhoto(target.files[0]);
          setTermsAndConditionThumbnail({ data: fileObj.uri, name: fileObj.name });
        }
        else if (type === 'bgv') {
          if (bgvConsentPreview?.id) {
            setAttachments(attachments.filter(e => e !== bgvConsentPreview.id))
            setDeleteDocs([...deleteDocs, bgvConsentPreview.id])
          }
          setBgvConsentFile(target.files[0]);
          setBgvConsentPreview({ data: fileObj.uri, name: fileObj.name });
        }
        else if (type === 'thumb') {
          if (thumbPreview?.id) {
            setAttachments(attachments.filter(e => e !== thumbPreview.id))
            setDeleteDocs([...deleteDocs, thumbPreview.id])
          }
          setThumbFile(target.files[0]);
          setThumbPreview({ data: fileObj.uri, name: fileObj.name });
        }
        if (type === 'aadhar') {
          if (aadharPreview?.id) {
            setAttachments(attachments.filter(e => e !== aadharPreview.id))
            setDeleteDocs([...deleteDocs, aadharPreview.id])
          }
          setAadharFile(target.files[0]);
          setAadharPreview({ data: fileObj.uri, name: fileObj.name });
        }
        else if (type === 'pan') {
          if (panCardPreview?.id) {
            setAttachments(attachments.filter(e => e !== panCardPreview.id))
            setDeleteDocs([...deleteDocs, panCardPreview.id])
          }
          setPanCardFile(target.files[0]);
          setPanCardPreview({ data: fileObj.uri, name: fileObj.name });
        }
        else if (type === 'passbook') {
          if (passbookPreview?.id) {
            setAttachments(attachments.filter(e => e !== passbookPreview.id))
            setDeleteDocs([...deleteDocs, passbookPreview.id])
          }
          setPassbookFile(target.files[0]);
          setPassbookPreview({ data: fileObj.uri, name: fileObj.name });
        }
        else if (type === 'bvc') {
          if (bvcPreview?.id) {
            setAttachments(attachments.filter(e => e !== bvcPreview.id))
            setDeleteDocs([...deleteDocs, bvcPreview.id])
          }
          setBvcFile(target.files[0]);
          setBvcPreview({ data: fileObj.uri, name: fileObj.name });
        }
        else if (type === 'pvc') {
          if (pvcPreview?.id) {
            setAttachments(attachments.filter(e => e !== pvcPreview.id))
            setDeleteDocs([...deleteDocs, pvcPreview.id])
          }
          setPvcFile(target.files[0]);
          setPvcPreview({ data: fileObj.uri, name: fileObj.name });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSelectSignatureFile = (event: any) => {
    const target = event.target as HTMLInputElement;

    if (target.files && target.files[0]) {
      setSelectedSignatureFile(target.files[0]);
      setSignatureImage(URL.createObjectURL(target.files[0]));
    }
  };


  const [gender, setGender] = React.useState('male');

  const handleGenderChange = (
    event: React.MouseEvent<HTMLElement>,
    newgender: string,
  ) => {
    setGender(newgender);
  };

  const UploadAllFiles = async () => {
    const fileOptions = [
      { fileObj: termsAndConditionPhoto, objName: 'termsAndConditionPhoto' },
      { fileObj: bgvConsentFile, objName: 'bgvConsentPhoto' },
      { fileObj: thumbFile, objName: 'thumbPhoto' },
      { fileObj: pvcFile, objName: 'pvc' },
      { fileObj: bvcFile, objName: 'bvc' },
      { fileObj: aadharFile, objName: 'aadharCard' },
      { fileObj: panCardFile, objName: 'panCard' },
      { fileObj: passbookFile, objName: 'passbook' },
    ];

    const attachmentsData = await Promise.all(
      fileOptions.map(async (file) => {
        const fileId = await UploadFile(file.fileObj, file.objName);
        if (fileId) return fileId;
        else return null;
      })
    );

    return attachmentsData.filter(e => e !== null);
  };

  const UploadFile = async (dataObj: any, objName: any) => {
    if (dataObj) {
      const fileForm: any = new FormData();
      fileForm.append('attachment', dataObj);
      fileForm.append('documentName', objName);
      let fileResObj: any = await dispatch(addDoc(fileForm));
      if (fileResObj?.payload && fileResObj?.payload?.doc._id) {
        return fileResObj?.payload?.doc._id
      }
    }
  }

  const DeleteDocs = async (ids: any) => {
    if (ids && ids.length > 0) {
      ids.map(async (id: any) => {
        await dispatch(deleteDoc(id));
      })
    }
  }

  return (
    <FormProvider {...methods}>
      <Box component="form" onSubmit={methods.handleSubmit(data => onSubmit(data), (errors) => {
        const firstError = Object.values(errors)[0];
        if (firstError?.message) {
          toast.error(String(firstError.message));
        } else {
          toast.error("Please fill all required fields");
        }
      })} ref={formRef} noValidate>
        <Grid container p={0} spacing={2} position={'fixed'} mt={-2} zIndex={999}>
          <Grid item xs={8}>
            <Box sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#fff' }}>
              <Grid container>
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, pt: 1.5, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                  <div style={{ float: 'right', marginTop: -5, marginRight: -5 }}>
                    {<LoadingButton
                      className={'buttonContainedRoot'}
                      size='small'
                      type="button"
                      name={'submit'}
                      loading={status === ApiStatus.LOADING}
                      style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7 }}
                      variant="contained"
                      onClick={() => {
                        if (!worksForSelf && !selectedClient) {
                          toast.error("Please select a Client and Base Location OR check 'Self Employee'");
                          return;
                        }
                        if (!worksForSelf && !selectedWorkLocation && selectedClient && !baseLocation) {
                          toast.error("Please select a Base Location for the selected client");
                          return;
                        }
                        if (!worksForSelf && !selectedWorkLocation && selectedClient && selectedClient._id === '') {
                          toast.error("Please select a valid Work Location OR Client and Base Location OR check 'Self Employee'");
                          return;
                        }
                        methods.handleSubmit(data => onSubmit(data))();
                      }}
                    >
                      {isEditing ? "Update" : "Create"}
                    </LoadingButton>}
                    {isEditing &&
                      <IconButton
                        style={{ color: '#c33b3b', backgroundColor: '#fff', border: '0.1px solid #c33b3b', height: 35, width: 35, marginLeft: 10 }}
                        size='small' ><DeleteIcon style={{ fontSize: 16 }} />
                      </IconButton>}
                  </div>
                  <IconButton onClick={() => {
                    methods.reset();
                    onCancel();
                  }}
                    style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 15, marginLeft: -5 }}
                    size='small'
                  >
                    <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
                  </IconButton>
                  <h3 style={{ marginTop: -1, fontWeight: 600 }}>{isEditing ? `Edit Employee : ${methods.getValues("name") || ''}` : "New Employee"}</h3>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <div style={{ height: 80, backgroundColor: '#fafafb', position: 'sticky', top: 0, zIndex: 990, marginLeft: -5, marginRight: -5 }} />

        <Grid container p={0} spacing={2} pt={0}>
          <Grid item xs={9}>

            {/* <div style={{ float: 'right', marginTop: 7, marginRight: 20 }}>
              {value > 0 && <Button
                onClick={() => setValue(value - 1)}
                style={{ color: '#635ee7', backgroundColor: 'transparent', borderBottom: '2px solid #635ee7', height: 35, borderRadius: 0 }}
                size='small' ><KeyboardArrowLeftIcon style={{ fontSize: 18 }} /> Previous
              </Button>}
              {value < 3 && <Button
                onClick={() => setValue(value + 1)}
                style={{ color: '#635ee7', backgroundColor: 'transparent', borderBottom: '2px solid #635ee7', height: 35, borderRadius: 0, marginLeft: 15 }}
                size='small' >Next <KeyboardArrowRightIcon style={{ fontSize: 18 }} />
              </Button>}
            </div> */}

            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="styled tabs example"
            >
              <StyledTab label="General" />
              <StyledTab label="Family" />
              <StyledTab label="Education" />
              <StyledTab label="Employement" />
              <StyledTab label="Bank Details" />
            </StyledTabs>

            <StyledTabPanel value={value} index={0} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2}>
                  <Grid item xs={3.5}>
                    <div className={'c-card2'} style={{ padding: 12, paddingTop: 10 }}>
                      <Grid container spacing={2} >
                        <Grid item xs={12} textAlign={'center'}>
                          {profileImage ?
                            <div className="file-name" style={{ marginBottom: "0px" }}>
                              <HighlightOffTwoToneIcon onClick={() => setProfileImage('')} sx={{ cursor: 'pointer', float: 'right', marginTop: '1.2px', marginLeft: '-12px', color: '#9da7b7', fontSize: 20 }} />
                              <img
                                src={profileImage}
                                style={{ marginTop: 10, width: 150, height: 150, border: '1px dashed #e9ecf1', borderRadius: 12, cursor: 'pointer', objectFit: "contain" }}
                              />
                            </div>
                            :
                            <div style={{ width: 150, margin: 'auto', marginBottom: "6px", marginTop: 10 }}>
                              <label htmlFor="photo">
                                <StyledInput
                                  accept="image/*"
                                  id="photo"
                                  type="file"
                                  onChange={handleSelectProfileFile}
                                />
                                <div style={{ width: 150, height: 150, border: '1px dashed #488dff', textAlign: 'center', borderRadius: 12, color: '#488dff', paddingTop: 50, cursor: 'pointer' }}>
                                  Click To Upload<br />Profile Photo
                                </div>
                              </label>
                            </div>}
                        </Grid>
                        <Grid item xs={12}>
                          <h5 className='c-label2'>Employee ID*</h5>
                          <TextField
                            placeholder="Employee ID"
                            required
                            disabled
                            {...methods.register("empId")}
                            className='c-text-field-4'
                            variant="standard"
                            sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                            size='small'
                            InputProps={{
                              disableUnderline: true,
                            }}
                          />
                          <p style={{ color: "#c33b3b" }}>{methods.formState.errors.empId?.message ?? ""}</p>
                        </Grid>

                        <Grid item xs={12}>
                          <h5 className='c-label2'>Employee Name*</h5>
                          <TextField
                            placeholder="Employee Name"
                            required
                            {...methods.register("name")}
                            className='c-text-field-4'
                            variant="standard"
                            sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                            size='small'
                            InputProps={{
                              disableUnderline: true,
                            }}
                          />
                          <p style={{ color: "#c33b3b" }}>{methods.formState.errors.name?.message ?? ""}</p>
                        </Grid>

                        <Grid item xs={12}>
                          <h5 className='c-label2'>Gender </h5>
                          <ToggleButtonGroup
                            value={gender}
                            exclusive
                            size='small'
                            onChange={handleGenderChange}
                            sx={{ width: '100% !important', mt: 0.5, borderRadius: '8px!important' }}
                          >
                            <ToggleButton className='c_radio' style={{ marginRight: 10, width: '33.33%' }} value="male">Male</ToggleButton>
                            <ToggleButton className='c_radio' style={{ marginRight: 10, width: '33.33%' }} value="female">Female</ToggleButton>
                            <ToggleButton className='c_radio' style={{ width: '33.33%' }} value="other">Other</ToggleButton>
                          </ToggleButtonGroup>
                          {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.name?.message ?? ""}</p> */}
                        </Grid>

                        <Grid item xs={12}>
                          <h5 className='c-label2'>Date Of Birth*</h5>
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            maxDate={moment().add(1).toDate()}
                            value={dobDate || ''}
                            InputProps={{
                              disableUnderline: true,
                              style: {
                                fontSize: 14,
                                height: 28
                              },
                            }}
                            onChange={(value) => { handleDateChange(value, 'dob') }}
                            renderInput={(params) =>
                              <TextField {...params}
                                value={dobDate || ''}
                                {...methods.register("dob")}
                                required
                                className='c-text-field-4'
                                variant="standard"
                                sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                size='small'
                                placeholder="Date Of Resign"
                              />
                            }
                          />
                          <p style={{ color: "#c33b3b" }}>{methods.formState.errors.dob?.message ?? ""}</p>
                        </Grid>

                        <Grid item xs={12}>
                          <h5 className='c-label2'>Date Of Joining *</h5>
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            maxDate={moment().add(1).toDate()}
                            value={dateOfJoining || ''}
                            InputProps={{
                              disableUnderline: true,
                              style: {
                                fontSize: 14,
                                height: 28
                              },
                            }}
                            onChange={(value) => { handleDateChange(value, 'dateOfJoining') }}
                            renderInput={(params) =>
                              <TextField {...params}
                                {...methods.register("dateOfJoining")}
                                value={dateOfJoining || ''}
                                required
                                className='c-text-field-4'
                                variant="standard"
                                sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                size='small'
                                placeholder="Date Of Joining"
                              />
                            }
                          />
                          <p style={{ color: "#c33b3b" }}>{methods.formState.errors.dateOfJoining?.message ?? ""}</p>
                        </Grid>

                        <Grid item xs={12}>
                          <h5 className='c-label2'>Reporting To (Manager)</h5>
                          <Autocomplete
                            disablePortal
                            options={managerOptions}
                            getOptionLabel={(option: any) => option.label || ''}
                            value={managerOptions.find((opt: any) => opt.value === reportingTo) || null}
                            onChange={(_event: any, newValue: any) => {
                              const val = newValue ? newValue.value : '';
                              setReportingTo(val);
                              methods.setValue("reportingTo", val);
                            }}
                            onInputChange={(_event: any, value: string, reason: string) => {
                              if (managerSearchTimer.current) clearTimeout(managerSearchTimer.current);
                              if (reason === 'input') {
                                managerSearchTimer.current = setTimeout(() => {
                                  if (value.length >= 2) {
                                    fetchManagerOptions(value);
                                  } else {
                                    fetchManagerOptions();
                                  }
                                }, 400);
                              }
                              if (reason === 'clear') {
                                fetchManagerOptions();
                              }
                            }}
                            filterOptions={(x) => x}
                            isOptionEqualToValue={(option: any, value: any) => option.value === value?.value}
                            classes={{ paper: classes.paper }}
                            size='small'
                            sx={{ width: '100%', mt: 0.5 }}
                            renderInput={(params) =>
                              <TextField {...params}
                                className='c-text-field-4'
                                variant="standard"
                                placeholder="Select Manager"
                                size='small'
                                InputProps={{
                                  ...params.InputProps,
                                  disableUnderline: true,
                                }}
                              />
                            }
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <h5 className='c-label2' style={{ marginBottom: 5 }}>Language</h5>
                          <Select
                            className='c-text-field-4'
                            disableUnderline
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  border: "1.5px solid #e9ecf1",
                                  // width: 255,
                                  // marginLeft:'-29px !important',
                                  boxShadow: 'none',
                                  borderRadius: '5px'
                                }
                              }
                            }}
                            variant='outlined'
                            sx={{
                              width: '100%',
                              boxShadow: "none",
                              paddingTop: '0px !important',
                              borderRadius: '7px !important',
                              height: 'auto !important',
                              // fontSize:12,
                              '& .MuiOutlinedInput-input': { p: 0.7 },
                              // '& .MuiSelect-select': { p:0 },
                              marginBottom: '3px',
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            }}
                            id="demo-multiple-chip"
                            multiple
                            {...methods.register("languages")}
                            value={language}
                            onChange={handleLangaugeChange}
                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                            renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, ml: "-5px" }}>
                                {selected.map((value) => (
                                  <Chip size='small' style={{ height: 23, borderRadius: 7 }} key={value} label={value} />
                                ))}
                              </Box>
                            )}
                          >
                            <MenuItem value={0} key={0}>Select Language</MenuItem>
                            {languageNames.map((name) => (
                              <MenuItem
                                key={name}
                                value={name}
                              // style={getStyles(name, language, theme)}
                              >
                                <Checkbox checked={language.indexOf(name) > -1} />
                                <ListItemText primary={name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>

                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={8.5}>

                    {selectedClient ? <>
                      <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15 }}>
                        <Button
                          // disabled={!(emergencyContacts.name && emergencyContacts.phone && emergencyContacts.relation)}
                          size='small'
                          variant="contained"
                          style={{
                            float: "right",
                            color: '#488dff',
                            backgroundColor: '#fff',
                            border: '0.5px solid #488dff',
                            height: 25, borderRadius: 7
                          }}
                          onClick={() => { openCloseDrawer('buyer') }}
                        >Change Client
                        </Button>
                        <Button
                          size='small'
                          variant="contained"
                          style={{
                            float: "right",
                            color: '#c33b3b',
                            backgroundColor: '#fff',
                            border: '0.5px solid #c33b3b',
                            height: 25, borderRadius: 7, marginRight: 6
                          }}
                          onClick={() => {
                            setSelectedClient(null);
                            setSelectedOption('');
                            setBaseLocation('');
                          }}
                        >Remove Client
                        </Button>
                        <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Client Details</h5>
                        {/* <div className={'c-card2'} style={{backgroundColor:'transparent',padding:15,paddingTop:10,paddingBottom:10,marginBottom:15,border:'1px dashed #488dff',textAlign:'center'}}  onClick={() => { openCloseDrawer('buyer') }}>
                                      <h5 style={{fontWeight:'normal',color:'#488dff',fontSize:14}}><AddCircleOutlineOutlinedIcon style={{marginBottom:-2.8, fontSize:'16px'}}/> Change Client</h5>
                                    </div> */}
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <Grid container spacing={2}>
                          <Grid item xs={2}>
                            <img src={Client} style={{ marginTop: 5, width: '100%', height: 'auto', padding: 5, borderRadius: 15, border: '.5px solid #e9ecf1', objectFit: 'cover' }} />
                          </Grid>
                          <Grid item xs={10}>
                            <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Client Name</h5>
                            <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 10 }}>{selectedClient?.name || '-'}</h5>
                            <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Base Location</h5>
                            <Select
                              placeholder='Base Location'
                              className='c-text-field-4'
                              disableUnderline
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    border: "1.5px solid #e9ecf1",
                                    // width: 255,
                                    // marginLeft:'-29px !important',
                                    boxShadow: 'none',
                                    borderRadius: '5px'
                                  }
                                }
                              }}
                              variant='outlined'
                              sx={{
                                width: '100%',
                                boxShadow: "none",
                                paddingTop: '0px !important',
                                borderRadius: '7px !important',
                                marginTop: '4px',
                                // fontSize:12,
                                '& .MuiOutlinedInput-input': { p: 0.7 },
                                // '& .MuiSelect-select': { p:0 },
                                marginBottom: '3px',
                                ".MuiOutlinedInput-notchedOutline": { border: 0 },
                                "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              }}
                              value={baseLocation || 0}
                              onChange={(event: SelectChangeEvent<any>) => {
                                methods.setValue("baseLocation", event.target.value);
                                setBaseLocation(event.target.value);
                              }}
                            >
                              <MenuItem value={0} key={0}>Select Location</MenuItem>
                              {selectedClientAddreesOptions.map(option => (
                                <MenuItem
                                  value={option.value}
                                  key={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              ))
                              }
                            </Select>
                            <p style={{ color: "#c33b3b" }}>{methods.formState.errors.baseLocation?.message ?? ""}</p>
                          </Grid>
                        </Grid>
                      </div>

                      <div className={'c-card2'} style={{ padding: 15, paddingTop: 12, paddingBottom: 12, marginBottom: 15 }}>
                        <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 14, marginBottom: 8 }}>Work Location</h5>
                        <Select
                          displayEmpty
                          variant='outlined'
                          sx={{
                            width: '100%',
                            borderRadius: '7px !important',
                            '& .MuiOutlinedInput-input': { p: 0.9 },
                            ".MuiOutlinedInput-notchedOutline": { borderColor: '#e9ecf1' },
                          }}
                          value={selectedWorkLocation || ''}
                          onChange={(e: any) => setSelectedWorkLocation(e.target.value)}
                        >
                          <MenuItem value=''>Select Work Location</MenuItem>
                          {selectedAccount?.location && (selectedAccount.location.title || selectedAccount.location.address) && (
                            <MenuItem value={`business:${selectedAccount.location.title || selectedAccount.location.address}`}>
                              {(selectedAccount.location.title || 'Business Profile')}{selectedAccount.location.address ? ` — ${selectedAccount.location.address}` : ''}
                            </MenuItem>
                          )}
                          {adminAddresses.map((addr: any) => {
                            const id = addr._id || addr.id;
                            const title = addr.title || addr.type || '';
                            const addressParts = [addr.line1, addr.line2, addr.city, addr.state?.name || addr.state, addr.country?.name || addr.country, addr.code].filter(Boolean).join(', ');
                            const label = title ? (addressParts ? `${title}, ${addressParts}` : title) : addressParts;
                            return (
                              <MenuItem key={id} value={`address:${id}`}>{label || id}</MenuItem>
                            );
                          })}
                        </Select>
                        {!(selectedAccount?.location && (selectedAccount.location.title || selectedAccount.location.address)) && adminAddresses.length === 0 && (
                          <p style={{ color: "#9da7b7", fontSize: 12, margin: '6px 0 0' }}>No business location or saved addresses. Add from Company Profile.</p>
                        )}
                      </div>

                    </>
                      :
                      <>
                        <div
                          className={'c-card2'}
                          style={{
                            backgroundColor: 'transparent',
                            padding: 15,
                            paddingTop: 17,
                            paddingBottom: 17,
                            marginBottom: 0,
                            border: worksForSelf ? '1px dashed #ccc' : '1px dashed #488dff',
                            textAlign: 'center',
                            cursor: worksForSelf ? 'not-allowed' : 'pointer',
                            opacity: worksForSelf ? 0.5 : 1
                          }}
                          onClick={() => { !worksForSelf && openCloseDrawer('buyer') }}
                        >
                          <h5 style={{ fontWeight: 'normal', color: worksForSelf ? '#ccc' : '#488dff', fontSize: 14, margin: 0 }}>
                            <AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} /> Click Here To Add Client
                          </h5>
                        </div>

                        <div style={{ textAlign: 'center', margin: '8px 0', color: '#aab4c4', fontSize: 13 }}>OR</div>

                        <div
                          className={'c-card2'}
                          style={{
                            backgroundColor: 'transparent',
                            padding: 15,
                            paddingTop: 17,
                            paddingBottom: 17,
                            marginBottom: 0,
                            marginTop: 0,
                            border: selectedClient ? '1px dashed #ccc' : '1px dashed #488dff',
                            textAlign: 'center',
                            cursor: selectedClient ? 'not-allowed' : 'pointer',
                            opacity: selectedClient ? 0.5 : 1,
                          }}
                          onClick={() => {
                            if (selectedClient) return;
                            setWorksForSelf(!worksForSelf);
                            if (!worksForSelf) {
                              setSelectedClient(null);
                              setSelectedOption('');
                              setBaseLocation('');
                            }
                          }}
                        >
                          <h5 style={{ fontWeight: 'normal', color: selectedClient ? '#ccc' : '#488dff', fontSize: 14, margin: 0 }}>
                            <Checkbox
                              checked={worksForSelf}
                              disabled={!!selectedClient}
                              size="small"
                              sx={{ color: '#488dff', '&.Mui-checked': { color: '#488dff' }, p: 0, mr: 0.5, mb: '-2px' }}
                              onClick={e => e.stopPropagation()}
                              onChange={(e) => {
                                if (selectedClient) return;
                                setWorksForSelf(e.target.checked);
                                if (e.target.checked) {
                                  setSelectedClient(null);
                                  setSelectedOption('');
                                  setBaseLocation('');
                                }
                              }}
                            />
                            Self Employee
                          </h5>
                        </div>

                        <div className={'c-card2'} style={{ padding: 15, paddingTop: 12, paddingBottom: 12, marginBottom: 15, marginTop: 20 }}>
                          <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 14, marginBottom: 8 }}>Work Location</h5>
                          <Select
                            displayEmpty
                            variant='outlined'
                            sx={{
                              width: '100%',
                              borderRadius: '7px !important',
                              '& .MuiOutlinedInput-input': { p: 0.9 },
                              ".MuiOutlinedInput-notchedOutline": { borderColor: '#e9ecf1' },
                            }}
                            value={selectedWorkLocation || ''}
                            onChange={(e: any) => setSelectedWorkLocation(e.target.value)}
                          >
                            <MenuItem value=''>Select Work Location</MenuItem>
                            {selectedAccount?.location && (selectedAccount.location.title || selectedAccount.location.address) && (
                              <MenuItem value={`business:${selectedAccount.location.title || selectedAccount.location.address}`}>
                                {(selectedAccount.location.title || 'Business Profile')}{selectedAccount.location.address ? ` — ${selectedAccount.location.address}` : ''}
                              </MenuItem>
                            )}
                            {adminAddresses.map((addr: any) => {
                              const id = addr._id || addr.id;
                              const title = addr.title || addr.type || '';
                              const addressParts = [addr.line1, addr.line2, addr.city, addr.state?.name || addr.state, addr.country?.name || addr.country, addr.code].filter(Boolean).join(', ');
                              const label = title ? (addressParts ? `${title}, ${addressParts}` : title) : addressParts;
                              return (
                                <MenuItem key={id} value={`address:${id}`}>{label || id}</MenuItem>
                              );
                            })}
                          </Select>
                          {!(selectedAccount?.location && (selectedAccount.location.title || selectedAccount.location.address)) && adminAddresses.length === 0 && (
                            <p style={{ color: "#9da7b7", fontSize: 12, margin: '6px 0 0' }}>No business location or saved addresses. Add from Company Profile.</p>
                          )}
                        </div>
                      </>
                    }

                    <div className={'c-card2'}>
                      <div style={{ padding: 15, paddingTop: 10, paddingBottom: 10 }}>
                        <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Contact Details</h5>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <Grid container spacing={2}>
                          <Grid item xs={4} >
                            <h5 className='c-label2'>Personal Email*</h5>
                            <TextField
                              placeholder="Email"
                              required
                              {...methods.register("personalEmail")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            <p style={{ color: "#c33b3b" }}>{methods.formState.errors.personalEmail?.message ?? ""}</p>
                          </Grid>

                          <Grid item xs={4} >
                            <h5 className='c-label2'>Phone*</h5>
                            <TextField
                              placeholder="Phone"
                              {...methods.register("primaryPhone")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            <p style={{ color: "#c33b3b" }}>{methods.formState.errors.primaryPhone?.message ?? ""}</p>
                          </Grid>

                          <Grid item xs={4} >
                            <h5 className='c-label2'>Alternate Phone</h5>
                            <TextField
                              placeholder="Alternate Phone"
                              required
                              {...methods.register("alternatePhone")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Address selected={selected} methods={methods} isEdit={isEditing} addressType="Employee" />
                        </Grid>
                      </div>

                    </div>
                  </Grid>
                </Grid>
              </LocalizationProvider>
            </StyledTabPanel>

            <StyledTabPanel value={value} index={1} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2}>

                  <Grid item xs={12}>

                    <div className={'c-card2'}>
                      <div style={{ padding: 15, paddingTop: 10, paddingBottom: 10 }}>
                        <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Family Details</h5>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <Grid container spacing={2}>

                          <Grid item xs={3}>
                            <h5 className='c-label2'>Father Name</h5>
                            <TextField
                              placeholder="Father Name"
                              required
                              {...methods.register("fatherName")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            <p style={{ color: "#c33b3b" }}>{methods.formState.errors.fatherName?.message ?? ""}</p>
                          </Grid>

                          <Grid item xs={3} >
                            <h5 className='c-label2'>Mother Name</h5>
                            <TextField
                              placeholder="Mother Name"
                              required
                              {...methods.register("motherName")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            <p style={{ color: "#c33b3b" }}>{methods.formState.errors.motherName?.message ?? ""}</p>
                          </Grid>

                          <Grid item xs={3} >
                            <div style={{ float: 'right', marginTop: -5, marginBottom: -7 }}>
                              <BpRadio {...methods.register("isMarried")} checked={isMarried == true} onChange={() => {
                                setIsMarried(true);
                              }} size="small" style={{ marginRight: -3 }} />
                              <label onClick={() => {
                                setIsMarried(true);
                              }}>Yes</label>
                              <BpRadio {...methods.register("isMarried")} checked={isMarried == false} onChange={() => {
                                setIsMarried(false);
                              }} size="small" style={{ marginRight: -3, marginLeft: 5 }} />
                              <label onClick={() => {
                                setIsMarried(false);
                              }}>No</label>
                            </div>
                            <h5 className='c-label2'>Is Married ?</h5>
                            <TextField
                              disabled={!isMarried}
                              placeholder="Spouse Full Name"
                              required
                              {...methods.register("spouseName")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={3} >
                            <h5 className='c-label2'>&nbsp;</h5>
                            <TextField
                              disabled={!isMarried}
                              placeholder="Spouse Phone"
                              required
                              {...methods.register("spousePhone")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} mb={-1}>
                            <Divider sx={{ mb: 1 }} />
                            <Button
                              disabled={!(emergencyContacts.name && emergencyContacts.phone && emergencyContacts.relation)}
                              size='small'
                              variant="contained"
                              style={{
                                float: "right",
                                color: !(emergencyContacts.name && emergencyContacts.phone && emergencyContacts.relation) ? '#9da7b7' : '#488dff',
                                backgroundColor: '#fff',
                                border: !(emergencyContacts.name && emergencyContacts.phone && emergencyContacts.relation) ? '0.5px solid #9da7b7' : '0.5px solid #488dff',
                                height: 25, borderRadius: 7
                              }}
                              onClick={(e) => {
                                const e_data = [...emergencyContacts.data];
                                e_data.push({
                                  id: emergencyContacts.data.length + 1,
                                  name: emergencyContacts.name,
                                  relation: emergencyContacts.relation,
                                  phone: emergencyContacts.phone
                                })
                                setEmergencyContacts({ name: '', relation: '', phone: '', data: e_data });
                              }}
                            >Add
                            </Button>
                            <h5 className='c-label2'>Emergency Contacts (max. 3)</h5>
                          </Grid>

                          <Grid item xs={4} >
                            <TextField
                              placeholder="Contact Name*"
                              className='c-text-field-4'
                              variant="standard"
                              disabled={emergencyContacts.data.length === 3}
                              value={emergencyContacts.name}
                              onChange={(e) => setEmergencyContacts({ ...emergencyContacts, name: e.target.value })}
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={4} >
                            <TextField
                              placeholder="Phone No.*"
                              value={emergencyContacts.phone}
                              disabled={emergencyContacts.data.length === 3}
                              onChange={(e) => setEmergencyContacts({ ...emergencyContacts, phone: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Select
                              className='c-text-field-4'
                              disableUnderline
                              disabled={emergencyContacts.data.length === 3}
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    border: "1.5px solid #e9ecf1",
                                    boxShadow: 'none',
                                    borderRadius: '5px'
                                  }
                                }
                              }}
                              variant='outlined'
                              sx={{
                                width: '100%',
                                boxShadow: "none",
                                paddingTop: '0px !important',
                                borderRadius: '7px !important',
                                marginTop: '4px',
                                '& .MuiOutlinedInput-input': { p: 0.7 },
                                marginBottom: '3px',
                                ".MuiOutlinedInput-notchedOutline": { border: 0 },
                                "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              }}
                              value={emergencyContacts.relation || 0}
                              onChange={(e) => setEmergencyContacts({ ...emergencyContacts, relation: String(e.target.value) })}
                            >
                              <MenuItem value={0} key={0}>Select Relation*</MenuItem>
                              {familyRelationOptions.map(option => (
                                <MenuItem
                                  value={option.value}
                                  key={option.value}
                                  disabled={option.disable || false}
                                >
                                  {option.label}
                                </MenuItem>
                              ))
                              }
                            </Select>
                          </Grid>

                          {emergencyContacts.data && emergencyContacts.data.length > 0 &&
                            <Grid item xs={12}>
                              <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell width={220}>Contact Name</StyledTableCell>
                                    <StyledTableCell width={210}>Phone No.</StyledTableCell>
                                    <StyledTableCell width={155}>Relation</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {emergencyContacts.data.map(e =>
                                    <StyledTableRow key={e.id}>
                                      <StyledTableCell>{e.name}</StyledTableCell>
                                      <StyledTableCell>{e.phone}</StyledTableCell>
                                      <StyledTableCell>{e.relation}</StyledTableCell>
                                      <StyledTableCell>
                                        <IconButton
                                          onClick={() => {
                                            const rows = emergencyContacts.data.filter((obj) => obj.id !== e.id);
                                            setEmergencyContacts({ name: '', relation: '', phone: '', data: rows });
                                          }}
                                          style={{ color: '#c33b3b', backgroundColor: '#fff', height: 25, width: 25, marginLeft: 10 }}
                                          size='small' ><DeleteIcon style={{ fontSize: 16 }} />
                                        </IconButton>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </Grid>}

                          <Grid item xs={12} mb={-1}>
                            <Divider sx={{ mb: 1 }} />
                            <Button
                              disabled={!(dependentsContacts.full_name && dependentsContacts.relation)}
                              size='small'
                              variant="contained"
                              style={{
                                float: "right",
                                color: !(dependentsContacts.full_name && dependentsContacts.relation) ? '#9da7b7' : '#488dff',
                                backgroundColor: '#fff',
                                border: !(dependentsContacts.full_name && dependentsContacts.relation) ? '0.5px solid #9da7b7' : '0.5px solid #488dff',
                                height: 25, borderRadius: 7
                              }}
                              onClick={(e) => {
                                const e_data = [...dependentsContacts.data];
                                e_data.push({
                                  id: dependentsContacts.data.length + 1,
                                  full_name: dependentsContacts.full_name,
                                  relation: dependentsContacts.relation,
                                  phone: dependentsContacts.phone,
                                  dob: dependentsContacts.dob
                                })
                                setDependentsContacts({ full_name: '', relation: '', phone: '', dob: undefined, data: e_data });
                              }}
                            >Add
                            </Button>
                            <h5 className='c-label2'>Dependents (max. 6)</h5>
                          </Grid>

                          <Grid item xs={3}>
                            <TextField
                              placeholder="Full Name*"
                              disabled={dependentsContacts.data.length === 6}
                              value={dependentsContacts.full_name}
                              onChange={(e) => setDependentsContacts({ ...dependentsContacts, full_name: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <Select
                              className='c-text-field-4'
                              disabled={dependentsContacts.data.length === 6}
                              value={dependentsContacts.relation || 0}
                              onChange={(e) => setDependentsContacts({ ...dependentsContacts, relation: String(e.target.value) })}
                              disableUnderline
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    border: "1.5px solid #e9ecf1",
                                    // width: 255,
                                    // marginLeft:'-29px !important',
                                    boxShadow: 'none',
                                    borderRadius: '5px'
                                  }
                                }
                              }}
                              defaultValue={null}
                              variant='outlined'
                              sx={{
                                width: '100%',
                                boxShadow: "none",
                                paddingTop: '0px !important',
                                borderRadius: '7px !important',
                                marginTop: '4px',
                                // fontSize:12,
                                '& .MuiOutlinedInput-input': { p: 0.7 },
                                // '& .MuiSelect-select': { p:0 },
                                marginBottom: '3px',
                                ".MuiOutlinedInput-notchedOutline": { border: 0 },
                                "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              }}
                            >
                              <MenuItem value={0} key={0}>Select Relation*</MenuItem>
                              {familyRelationOptions.map(option => (
                                <MenuItem
                                  value={option.value}
                                  key={option.value}
                                  disabled={option.disable || false}
                                >
                                  {option.label}
                                </MenuItem>
                              ))
                              }
                            </Select>
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.relation?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              disabled={dependentsContacts.data.length === 6}
                              value={dependentsContacts.dob || null}
                              onChange={(value) => { handleDateChange(value, 'dependent') }}
                              maxDate={moment().add(1).toDate()}
                              InputProps={{
                                disableUnderline: true,
                                style: {
                                  fontSize: 14,
                                  height: 28
                                },
                              }}
                              renderInput={(params) =>
                                <TextField {...params}
                                  value={dependentsContacts.dob || null}
                                  className='c-text-field-4'
                                  variant="standard"
                                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                  size='small'
                                  placeholder="Date Of Birth"
                                />
                              }
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.dob?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <TextField
                              placeholder="Phone No."
                              disabled={dependentsContacts.data.length === 6}
                              value={dependentsContacts.phone}
                              onChange={(e) => setDependentsContacts({ ...dependentsContacts, phone: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.phone?.message ?? ""}</p> */}
                          </Grid>

                        </Grid>
                      </div>

                      {dependentsContacts.data && dependentsContacts.data.length > 0 &&
                        <div style={{ marginBottom: 12 }}>
                          <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                            <TableHead>
                              <TableRow>
                                <StyledTableCell width={235}>Name</StyledTableCell>
                                <StyledTableCell width={230}>Relation</StyledTableCell>
                                <StyledTableCell width={225}>Date Of Birth</StyledTableCell>
                                <StyledTableCell width={165}>Phone No.</StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {dependentsContacts.data.map(e =>
                                <StyledTableRow key={e.id}>
                                  <StyledTableCell>{e.full_name}</StyledTableCell>
                                  <StyledTableCell>{e.relation}</StyledTableCell>
                                  <StyledTableCell>{moment(e.dob).format("DD MMM YYYY")}</StyledTableCell>
                                  <StyledTableCell>{e.phone}</StyledTableCell>
                                  <StyledTableCell>
                                    <IconButton
                                      onClick={() => {
                                        const rows = dependentsContacts.data.filter((obj) => obj.id !== e.id);
                                        setDependentsContacts({ full_name: '', relation: '', phone: '', dob: undefined, data: rows });
                                      }}
                                      style={{ color: '#c33b3b', backgroundColor: '#fff', height: 25, width: 25, marginLeft: 10 }}
                                      size='small' ><DeleteIcon style={{ fontSize: 16 }} />
                                    </IconButton>
                                  </StyledTableCell>
                                </StyledTableRow>
                              )}
                            </TableBody>
                          </Table>
                        </div>}

                    </div>
                  </Grid>
                </Grid>
              </LocalizationProvider>
            </StyledTabPanel>

            <StyledTabPanel value={value} index={2} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>

                    <div className={'c-card2'}>
                      <div style={{ padding: 15, paddingTop: 10, paddingBottom: 15 }}>
                        <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Education Details (max. 5)</h5>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <Grid container spacing={2}>

                          <Grid item xs={6}>
                            <h5 className='c-label2'>School/College Name*</h5>
                            <TextField
                              placeholder="School/College Name"
                              required
                              disabled={education.data.length === 5}
                              value={education.college}
                              onChange={(e) => setEducation({ ...education, college: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fatherName?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={6} >
                            <h5 className='c-label2'>University Name*</h5>
                            <TextField
                              placeholder="University Name"
                              required
                              disabled={education.data.length === 5}
                              value={education.university}
                              onChange={(e) => setEducation({ ...education, university: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.motherName?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <h5 className='c-label2'>Education Establishment</h5>
                            <Select
                              className='c-text-field-4'
                              disableUnderline
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    border: "1.5px solid #e9ecf1",
                                    // width: 255,
                                    // marginLeft:'-29px !important',
                                    boxShadow: 'none',
                                    borderRadius: '5px'
                                  }
                                }
                              }}
                              defaultValue={null}
                              variant='outlined'
                              sx={{
                                width: '100%',
                                boxShadow: "none",
                                paddingTop: '0px !important',
                                borderRadius: '7px !important',
                                marginTop: '4px',
                                // fontSize:12,
                                '& .MuiOutlinedInput-input': { p: 0.7 },
                                // '& .MuiSelect-select': { p:0 },
                                marginBottom: '3px',
                                ".MuiOutlinedInput-notchedOutline": { border: 0 },
                                "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              }}
                              disabled={education.data.length === 5}
                              value={education.education || 0}
                              onChange={(e) => setEducation({ ...education, education: String(e.target.value) })}
                            >
                              <MenuItem value={0} key={0}>Select Education </MenuItem>
                              <MenuItem value={'SSC'} key={1}>SSC</MenuItem>
                              <MenuItem value={'HSC'} key={2}>HSC</MenuItem>
                              <MenuItem value={'Polytechnic'} key={3}>Polytechnic</MenuItem>
                              <MenuItem value={'Bachlores'} key={4}>Bachlores</MenuItem>
                              <MenuItem value={'B.TECH'} key={5}>B.TECH</MenuItem>
                              <MenuItem value={'BE'} key={6}>BE</MenuItem>
                              <MenuItem value={'BCA'} key={7}>BCA</MenuItem>
                              <MenuItem value={'Masters'} key={8}>Masters</MenuItem>
                              <MenuItem value={'MBA'} key={9}>MBA</MenuItem>
                              <MenuItem value={'MCA'} key={10}>MCA</MenuItem>
                              <MenuItem value={'PHD'} key={11}>PHD</MenuItem>
                            </Select>
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.relation?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <h5 className='c-label2'>Course Description</h5>
                            <Select
                              className='c-text-field-4'
                              disableUnderline
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    border: "1.5px solid #e9ecf1",
                                    // width: 255,
                                    // marginLeft:'-29px !important',
                                    boxShadow: 'none',
                                    borderRadius: '5px'
                                  }
                                }
                              }}
                              defaultValue={null}
                              variant='outlined'
                              sx={{
                                width: '100%',
                                boxShadow: "none",
                                paddingTop: '0px !important',
                                borderRadius: '7px !important',
                                marginTop: '4px',
                                // fontSize:12,
                                '& .MuiOutlinedInput-input': { p: 0.7 },
                                // '& .MuiSelect-select': { p:0 },
                                marginBottom: '3px',
                                ".MuiOutlinedInput-notchedOutline": { border: 0 },
                                "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                              }}
                              disabled={education.data.length === 5}
                              value={education.course || 0}
                              onChange={(e) => setEducation({ ...education, course: String(e.target.value) })}
                            >
                              <MenuItem value={0} key={0}>Select Course </MenuItem>
                              <MenuItem value={'none'} key={1}>None</MenuItem>
                              <MenuItem value={'Computer Science'} key={2}>Computer Science</MenuItem>
                              <MenuItem value={'Science & Technology'} key={3}>Science & Technology</MenuItem>
                              <MenuItem value={'Humanitics'} key={4}>Humanitics</MenuItem>
                              <MenuItem value={'Commerce & Management'} key={5}>Commerce & Management</MenuItem>
                              <MenuItem value={'Interdisciplinary Studies'} key={6}>Interdisciplinary Studies</MenuItem>
                            </Select>
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.relation?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <h5 className='c-label2'>Start Date</h5>
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              maxDate={moment().add(1).toDate()}
                              disabled={education.data.length === 5}
                              value={education.start_date || null}
                              onChange={(value) => { handleDateChange(value, 'education start_date') }}
                              InputProps={{
                                disableUnderline: true,
                                style: {
                                  fontSize: 14,
                                  height: 28
                                },
                              }}
                              renderInput={(params) =>
                                <TextField {...params}
                                  value={education.start_date || null}
                                  required
                                  className='c-text-field-4'
                                  variant="standard"
                                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                  size='small'
                                  placeholder="Date Of Resign"
                                />
                              }
                            />
                          </Grid>

                          <Grid item xs={3} >
                            <h5 className='c-label2'>End Date</h5>
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              disabled={education.data.length === 5}
                              value={education.end_date || null}
                              onChange={(value) => { handleDateChange(value, 'education end_date') }}
                              InputProps={{
                                disableUnderline: true,
                                style: {
                                  fontSize: 14,
                                  height: 28
                                },
                              }}
                              renderInput={(params) =>
                                <TextField {...params}
                                  value={education.end_date || null}
                                  required
                                  className='c-text-field-4'
                                  variant="standard"
                                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                  size='small'
                                  placeholder="Date Of Resign"
                                />
                              }
                            />
                          </Grid>

                          <Grid item xs={3} mt={-1}>
                            <h5 className='c-label2'>Year Of Passing</h5>
                            <TextField
                              placeholder="Percentage"
                              required
                              disabled={education.data.length === 5}
                              value={education.passing_year}
                              onChange={(e) => setEducation({ ...education, passing_year: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={3} mt={-1} >
                            <h5 className='c-label2'>Percentage</h5>
                            <TextField
                              placeholder="Percentage"
                              required
                              disabled={education.data.length === 5}
                              value={education.percentage}
                              onChange={(e) => setEducation({ ...education, percentage: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={6} >
                            <Button
                              disabled={!(education.college &&
                                education.university &&
                                education.education &&
                                education.course &&
                                education.start_date &&
                                education.end_date &&
                                education.passing_year &&
                                education.percentage)}
                              size='small'
                              variant="contained"
                              style={{
                                float: "right",
                                color: !(education.college &&
                                  education.university &&
                                  education.education &&
                                  education.course &&
                                  education.start_date &&
                                  education.end_date &&
                                  education.passing_year &&
                                  education.percentage) ? '#9da7b7' : '#488dff',
                                backgroundColor: '#fff',
                                border: !(education.college &&
                                  education.university &&
                                  education.education &&
                                  education.course &&
                                  education.start_date &&
                                  education.end_date &&
                                  education.passing_year &&
                                  education.percentage) ? '0.5px solid #9da7b7' : '0.5px solid #488dff',
                                height: 35, borderRadius: 7, marginTop: 18
                              }}
                              onClick={(e) => {
                                const e_data = [...education.data];
                                e_data.push({
                                  id: education.data.length + 1,
                                  college: education.college,
                                  university: education.university,
                                  education: education.education,
                                  course: education.course,
                                  start_date: education.start_date,
                                  end_date: education.end_date,
                                  passing_year: education.passing_year,
                                  percentage: education.percentage
                                })
                                setEducation({
                                  college: '',
                                  university: '',
                                  education: '',
                                  course: '',
                                  start_date: undefined,
                                  end_date: undefined,
                                  passing_year: undefined,
                                  percentage: '',
                                  data: e_data
                                });
                              }}
                            >Add Details
                            </Button>
                          </Grid>

                        </Grid>
                      </div>

                      {education.data && education.data.length > 0 &&
                        <div style={{ marginBottom: 12 }}>
                          <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                            <TableHead>
                              <TableRow>
                                <StyledTableCell width={235}>School/College</StyledTableCell>
                                <StyledTableCell width={165}>University</StyledTableCell>
                                <StyledTableCell width={100}>Education</StyledTableCell>
                                <StyledTableCell width={100}>Course</StyledTableCell>
                                <StyledTableCell width={100}>Duration</StyledTableCell>
                                <StyledTableCell width={50}>Passing</StyledTableCell>
                                <StyledTableCell width={90}>Percentage</StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {education.data.map(e =>
                                <StyledTableRow key={e.id}>
                                  <StyledTableCell>{e.college}</StyledTableCell>
                                  <StyledTableCell>{e.university}</StyledTableCell>
                                  <StyledTableCell>{e.education}</StyledTableCell>
                                  <StyledTableCell>{e.course}</StyledTableCell>
                                  <StyledTableCell>{moment(e.start_date).format("YYYY")} - {moment(e.end_date).format("YYYY")}</StyledTableCell>
                                  <StyledTableCell>{moment(e.passing_year).format("YYYY")}</StyledTableCell>
                                  <StyledTableCell>{e.percentage}</StyledTableCell>
                                  <StyledTableCell>
                                    <IconButton
                                      onClick={() => {
                                        const rows = education.data.filter((obj) => obj.id !== e.id);
                                        setEducation({
                                          college: '',
                                          university: '',
                                          education: '',
                                          course: '',
                                          start_date: undefined,
                                          end_date: undefined,
                                          passing_year: undefined,
                                          percentage: '',
                                          data: rows
                                        });
                                      }}
                                      style={{ color: '#c33b3b', backgroundColor: '#fff', height: 25, width: 25, marginLeft: 10 }}
                                      size='small' ><DeleteIcon style={{ fontSize: 16 }} />
                                    </IconButton>
                                  </StyledTableCell>
                                </StyledTableRow>
                              )}
                            </TableBody>
                          </Table>
                        </div>}

                    </div>
                  </Grid>
                </Grid>
              </LocalizationProvider>
            </StyledTabPanel>

            <StyledTabPanel value={value} index={3} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>

                    <div className={'c-card2'}>
                      <div style={{ padding: 15, paddingTop: 10, paddingBottom: 15 }}>
                        <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Employement Details</h5>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <Grid container spacing={2}>

                          <Grid item xs={6}>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <h5 className='c-label2'>Gross Salary</h5>
                                <TextField
                                  placeholder="Gross Salary"
                                  type='number'
                                  {...methods.register("grossSalary")}
                                  className='c-text-field-4'
                                  variant="standard"
                                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                  size='small'
                                  InputProps={{
                                    disableUnderline: true,
                                  }}
                                />
                                <p style={{ color: "#c33b3b" }}>{methods.formState.errors.grossSalary?.message ?? ""}</p>
                              </Grid>
                              <Grid item xs={6} >
                                <h5 className='c-label2'>Cost To Compnay(CTC)</h5>
                                <TextField
                                  placeholder="CTC"
                                  type='number'
                                  {...methods.register("ctc")}
                                  className='c-text-field-4'
                                  variant="standard"
                                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                  size='small'
                                  InputProps={{
                                    disableUnderline: true,
                                  }}
                                />
                                <p style={{ color: "#c33b3b" }}>{methods.formState.errors.ctc?.message ?? ""}</p>
                              </Grid>
                              <Grid item xs={6}>
                                <h5 className='c-label2'>Assessment Year</h5>
                                <TextField
                                  placeholder="Ex. FY 2023-2024"
                                  {...methods.register("assessmentYear")}
                                  className='c-text-field-4'
                                  variant="standard"
                                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                  size='small'
                                  InputProps={{
                                    disableUnderline: true,
                                  }}
                                />
                                <p style={{ color: "#c33b3b" }}>{methods.formState.errors.assessmentYear?.message ?? ""}</p>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={6}>
                            <h5 className='c-label2'>Signature</h5>
                            {signatureImage ?
                              <div style={{ width: '50%', marginTop: 5 }}>
                                <HighlightOffTwoToneIcon onClick={() => setSignatureImage('')} sx={{ zIndex: -1, cursor: 'pointer', float: 'right', marginBottom: '-10px', marginRight: '-5px', color: '#9da7b7', fontSize: 20 }} />
                                <img
                                  src={signatureImage}
                                  alt="Signature"
                                  style={{ width: '150px', height: "150px", border: '1px dashed #e9ecf1', borderRadius: 12, cursor: 'pointer', objectFit: "contain" }}
                                />
                              </div>
                              :
                              <div style={{ width: '100%', marginTop: 5 }}>
                                <label htmlFor="signature">
                                  <StyledInput
                                    accept="image/*"
                                    id="signature"
                                    type="file"
                                    onChange={handleSelectSignatureFile}
                                  />
                                  <div style={{ width: '100%', height: 110, border: '1px dashed #488dff', textAlign: 'center', borderRadius: 12, color: '#488dff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div>Click Here To Upload<br />Signature</div>
                                  </div>
                                </label>
                              </div>}
                          </Grid>

                          <Grid item xs={12} mb={-1}>
                            <Divider sx={{ mb: 1 }} />
                            <h5 className='c-label2'>Pre-Employer Details</h5>
                          </Grid>

                          <Grid item xs={3}>
                            <TextField
                              placeholder="Employer Name"
                              // disabled={preEmpolyer.data.length === 5}
                              value={preEmpolyer.name}
                              onChange={(e) => setPreEmployer({ ...preEmpolyer, name: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <TextField
                              placeholder="Title"
                              // disabled={preEmpolyer.data.length === 5}
                              value={preEmpolyer.title}
                              onChange={(e) => setPreEmployer({ ...preEmpolyer, title: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <TextField
                              placeholder="Gross Salary"
                              // disabled={preEmpolyer.data.length === 5}
                              value={preEmpolyer.gross_salary}
                              onChange={(e) => setPreEmployer({ ...preEmpolyer, gross_salary: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <TextField
                              placeholder="CTC"
                              // disabled={preEmpolyer.data.length === 5}
                              value={preEmpolyer.ctc}
                              onChange={(e) => setPreEmployer({ ...preEmpolyer, ctc: e.target.value })}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                            {/* <p style={{color: "#c33b3b"}}>{methods.formState.errors.fullName?.message ?? ""}</p> */}
                          </Grid>

                          <Grid item xs={3}>
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              maxDate={moment().add(1).toDate()}
                              // disabled={preEmpolyer.data.length === 5}
                              value={preEmpolyer.start_date || null}
                              onChange={(value) => { handleDateChange(value, 'preEmpolyer start_date') }}
                              InputProps={{
                                disableUnderline: true,
                                style: {
                                  fontSize: 14,
                                  height: 28
                                },
                              }}
                              renderInput={(params) =>
                                <TextField {...params}
                                  value={preEmpolyer.start_date || null}
                                  required
                                  className='c-text-field-4'
                                  variant="standard"
                                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                  size='small'
                                  placeholder="Date Of Joining"

                                />}
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              // disabled={preEmpolyer.data.length === 5}
                              value={preEmpolyer.end_date || null}
                              onChange={(value) => { handleDateChange(value, 'preEmpolyer end_date') }}
                              InputProps={{
                                disableUnderline: true,
                                style: {
                                  fontSize: 14,
                                  height: 28
                                },
                              }}
                              renderInput={(params) =>
                                <TextField {...params}
                                  value={preEmpolyer.end_date || null}
                                  className='c-text-field-4'
                                  variant="standard"
                                  sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                                  size='small'
                                  required
                                  placeholder="Date Of Resign"

                                />}
                            />
                          </Grid>

                          <Grid item xs={6} >
                            <Button
                              disabled={!(preEmpolyer.name &&
                                preEmpolyer.title &&
                                preEmpolyer.gross_salary &&
                                preEmpolyer.ctc &&
                                preEmpolyer.start_date &&
                                preEmpolyer.end_date)}
                              size='small'
                              variant="contained"
                              style={{
                                float: "right",
                                color: !(preEmpolyer.name &&
                                  preEmpolyer.title &&
                                  preEmpolyer.gross_salary &&
                                  preEmpolyer.ctc &&
                                  preEmpolyer.start_date &&
                                  preEmpolyer.end_date) ? '#9da7b7' : '#488dff',
                                backgroundColor: '#fff',
                                border: !(preEmpolyer.name &&
                                  preEmpolyer.title &&
                                  preEmpolyer.gross_salary &&
                                  preEmpolyer.ctc &&
                                  preEmpolyer.start_date &&
                                  preEmpolyer.end_date) ? '0.5px solid #9da7b7' : '0.5px solid #488dff',
                                height: 35, borderRadius: 7, marginTop: 6
                              }}
                              onClick={(e) => {
                                const e_data = [...preEmpolyer.data];
                                e_data.push({
                                  id: preEmpolyer.data.length + 1,
                                  name: preEmpolyer.name,
                                  title: preEmpolyer.title,
                                  gross_salary: preEmpolyer.gross_salary,
                                  ctc: preEmpolyer.ctc,
                                  start_date: preEmpolyer.start_date,
                                  end_date: preEmpolyer.end_date
                                })
                                setPreEmployer({
                                  name: '',
                                  title: '',
                                  gross_salary: '',
                                  ctc: '',
                                  start_date: undefined,
                                  end_date: undefined,
                                  data: e_data
                                });
                              }}
                            >Add Details
                            </Button>
                          </Grid>

                        </Grid>
                      </div>

                      {preEmpolyer.data && preEmpolyer.data.length > 0 &&
                        <div style={{ marginBottom: 12 }}>
                          <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                            <TableHead>
                              <TableRow>
                                <StyledTableCell width={235}>Employer Name</StyledTableCell>
                                <StyledTableCell width={225}>Title</StyledTableCell>
                                <StyledTableCell width={150}>Salary</StyledTableCell>
                                <StyledTableCell width={150}>CTC</StyledTableCell>
                                <StyledTableCell width={100}>Duration</StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {preEmpolyer.data.map(e =>
                                <StyledTableRow key={e.id}>
                                  <StyledTableCell>{e.name}</StyledTableCell>
                                  <StyledTableCell>{e.title}</StyledTableCell>
                                  <StyledTableCell>{e.gross_salary}</StyledTableCell>
                                  <StyledTableCell>{e.ctc}</StyledTableCell>
                                  <StyledTableCell>{moment(e.start_date).format("YYYY")} - {moment(e.end_date).format("YYYY")}</StyledTableCell>
                                  <StyledTableCell>
                                    <IconButton
                                      onClick={() => {
                                        const rows = preEmpolyer.data.filter((obj) => obj.id !== e.id);
                                        setPreEmployer({
                                          name: '',
                                          title: '',
                                          gross_salary: '',
                                          ctc: '',
                                          start_date: undefined,
                                          end_date: undefined,
                                          data: rows
                                        });
                                      }}
                                      style={{ color: '#c33b3b', backgroundColor: '#fff', height: 25, width: 25, marginLeft: 10 }}
                                      size='small' ><DeleteIcon style={{ fontSize: 16 }} />
                                    </IconButton>
                                  </StyledTableCell>
                                </StyledTableRow>
                              )}
                            </TableBody>
                          </Table>
                        </div>}

                    </div>
                  </Grid>
                </Grid>
                {/* <Grid container spacing={2} >
                  <Grid item xs={12}>
                    <div className={'c-card2'} style={{padding:15,paddingTop:10,paddingBottom:10}}>
                      {docData && <DocAttachInfo docList={docData} onDelete={docDelete} onClose={closeDoc12} />}
                    </div>
                  </Grid>
                </Grid> */}
              </LocalizationProvider>
            </StyledTabPanel>

            <StyledTabPanel value={value} index={4} >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <div className={'c-card2'}>
                      <div style={{ padding: 15, paddingTop: 10, paddingBottom: 10 }}>
                        <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Bank Account Details</h5>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <input type="hidden" {...methods.register("bankAccountId")} />
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <h5 className='c-label2'>Account Name</h5>
                            <TextField
                              placeholder="Account Name"
                              {...methods.register("bankAccountName")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <h5 className='c-label2'>Account Number</h5>
                            <TextField
                              placeholder="Account Number"
                              {...methods.register("bankAccountNumber")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <h5 className='c-label2'>Bank Name</h5>
                            <TextField
                              placeholder="Bank Name"
                              {...methods.register("bankName")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <h5 className='c-label2'>Branch Name</h5>
                            <TextField
                              placeholder="Branch Name"
                              {...methods.register("bankBranchName")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <h5 className='c-label2'>IFSC</h5>
                            <TextField
                              placeholder="IFSC"
                              {...methods.register("bankIFSC")}
                              className='c-text-field-4'
                              variant="standard"
                              sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                              size='small'
                              InputProps={{
                                disableUnderline: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <h5 className='c-label2'>Currency</h5>
                            {currencyOptions?.length > 0 && <Select
                              className='c-text-field-4'
                              {...methods.register("bankCurrency")}
                              disableUnderline
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    border: "1.5px solid #e9ecf1",
                                    boxShadow: 'none',
                                    borderRadius: '5px'
                                  }
                                }
                              }}
                              variant='outlined'
                              sx={{
                                width: '100%',
                                boxShadow: "none",
                                paddingTop: '0px !important',
                                borderRadius: '7px !important',
                                height: 'auto !important',
                                '& .MuiOutlinedInput-input': { p: 0.7 },
                                marginBottom: '3px',
                                marginTop: '5px',
                                ".MuiOutlinedInput-notchedOutline": { border: 0 },
                                "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                                  border: 0,
                                },
                                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                  border: 0,
                                },
                              }}
                              value={bankCurrency ?? ''}
                              onChange={(event: SelectChangeEvent<any>) => {
                                setBankCurrency(event.target.value);
                                methods.setValue("bankCurrency", event.target.value);
                              }}
                              size='small'
                            >
                              <MenuItem value="">Select Currency</MenuItem>
                              {currencyOptions.map((option) => (
                                <MenuItem value={option.value} key={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>}
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </LocalizationProvider>
            </StyledTabPanel>

          </Grid>

          <Grid item xs={3} mt={2}>
            <Grid container p={0} spacing={2}>
              <Grid item xs={12}>
                <div className={'c-card2'} style={{ padding: 12, paddingTop: 10, marginBottom: 15 }}>
                  {/* <Chip size='small' style={{height:18,float:'right',borderRadius:7,color:'#c33b3b',backgroundColor:'#fbecec',fontSize:12,marginTop:2}} label={<>KYC Pending<CloseIcon style={{fontSize:12,float:'right',marginTop:'3px',marginLeft:'3px',marginRight:'-2px'}} /></>}/> */}
                  <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#49a563', backgroundColor: '#edf6ef', fontSize: 12, marginTop: 2 }} label={<>KYC Done<CheckIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                  <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Compliance Details</h5>
                  <Divider sx={{ mt: 0.5, mb: 1 }} />
                  <Grid container spacing={2} >
                    <Grid item xs={12} >
                      <div style={{ float: 'right', marginTop: -5, marginBottom: -7 }}>
                        <BpRadio {...methods.register("isCompliance")} checked={isCompliance == true} onChange={() => {
                          setIsCompliance(true);
                        }} size="small" style={{ marginRight: -3 }} />
                        <label onClick={() => {
                          setIsCompliance(true);
                        }}>Yes</label>
                        <BpRadio {...methods.register("isCompliance")} checked={isCompliance == false} onChange={() => {
                          setIsCompliance(false);
                        }} size="small" style={{ marginRight: -3, marginLeft: 5 }} />
                        <label onClick={() => {
                          setIsCompliance(false);
                        }}>No</label>
                      </div>
                      <h5 className='c-label2'>Is Compliance ?</h5>
                    </Grid>
                    <Grid item xs={12}>
                      <h5 className='c-label2'>Nominee Name</h5>
                      <TextField
                        disabled={!isCompliance}
                        placeholder="Nominee Name"
                        required
                        {...methods.register("nomineeName")}
                        className='c-text-field-4'
                        variant="standard"
                        sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                        size='small'
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <h5 className='c-label2' style={{ marginBottom: 5 }}>Nominee Relation</h5>
                      <Select
                        className='c-text-field-4'
                        disableUnderline
                        disabled={!isCompliance}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1.5px solid #e9ecf1",
                              // width: 255,
                              // marginLeft:'-29px !important',
                              boxShadow: 'none',
                              borderRadius: '5px'
                            }
                          }
                        }}
                        variant='outlined'
                        sx={{
                          width: '100%',
                          boxShadow: "none",
                          paddingTop: '0px !important',
                          borderRadius: '7px !important',
                          height: 'auto !important',
                          // fontSize:12,
                          '& .MuiOutlinedInput-input': { p: 0.7 },
                          // '& .MuiSelect-select': { p:0 },
                          marginBottom: '3px',
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                          {
                            border: 0,
                          },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          {
                            border: 0,
                          },
                        }}
                        {...methods.register("nomineeRelation")}

                        value={selectedNomineeRelation || 0}
                        onChange={(event: SelectChangeEvent<any>) => {
                          methods.setValue("nomineeRelation", event.target.value);
                          setSelectedNomineeRelation(event.target.value);
                        }}
                      >
                        <MenuItem value={0} key={0}>Select Relation</MenuItem>
                        {familyRelationOptions.map(option => (
                          <MenuItem
                            value={option.value}
                            key={option.value}
                            disabled={option.disable || false}
                          >
                            {option.label}
                          </MenuItem>
                        ))
                        }
                      </Select>
                    </Grid>

                    <Grid item xs={12}>
                      <h5 className='c-label2'>Bank Linked Phone</h5>
                      <TextField
                        placeholder="Bank Linked Phone"
                        required
                        {...methods.register("bankLinkPhone")}
                        className='c-text-field-4'
                        variant="standard"
                        sx={{ width: '100%', mt: 0.5, borderRadius: '8px!important' }}
                        size='small'
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Grid>

                  </Grid>
                </div>

                {termsAndConditionThumbnail ?
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '0.1px solid #488dff' }}>
                    <HighlightOffTwoToneIcon onClick={() => { handleDeleteRefFile("t&c"); setTermsAndConditionPhoto(null); setTermsAndConditionThumbnail(null); }} style={{ color: '#c33b3b', fontSize: '18px', float: 'right' }} />
                    <h5 className='c-label2' style={{ fontWeight: 'normal', fontSize: 15 }}>Terms And Conditions</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />

                    <RemoveRedEyeTwoToneIcon
                      onClick={() => {
                        setDocumentModel(true)
                        setDocument({ name: "Terms And Conditions", document: termsAndConditionThumbnail?.data?.location ? termsAndConditionThumbnail?.data?.location : '' });
                      }} style={{ color: '#488dff', fontSize: '18px', float: 'right', marginTop: '2px' }}
                    />
                    <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><InsertDriveFileIcon style={{ marginBottom: -2.8, marginRight: 5, fontSize: '16px' }} />
                      {(termsAndConditionThumbnail.name.length > 30) ? `... ${termsAndConditionThumbnail.name.substring(10, 60)}` : termsAndConditionThumbnail.name}
                    </h5>
                  </div>
                  :
                  <div style={{ width: '100%', marginTop: 5 }}>
                    <label htmlFor="termsAndConditionPhoto">
                      <StyledInput
                        accept="file/*"
                        id="termsAndConditionPhoto"
                        type="file"
                        onChange={(e) => pickFile(e, "t&c")}
                      />
                      <div className={'c-card2'} style={{ backgroundColor: 'transparent', padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '1px dashed #488dff', textAlign: 'center' }}>
                        <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} />Add Terms And Conditions</h5>
                      </div>
                    </label>
                  </div>}

                {bgvConsentPreview ?
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '0.1px solid #488dff' }}>
                    <HighlightOffTwoToneIcon onClick={() => { handleDeleteRefFile("bgv"); setBgvConsentFile(null); setBgvConsentPreview(null); }} style={{ color: '#c33b3b', fontSize: '18px', float: 'right' }} />
                    <h5 className='c-label2' style={{ fontWeight: 'normal', fontSize: 15 }}>BGV Consent Form</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <RemoveRedEyeTwoToneIcon
                      onClick={() => {
                        setDocumentModel(true)
                        setDocument({ name: "BGV Consent Form", document: bgvConsentPreview?.data?.location ? bgvConsentPreview?.data?.location : '' });
                      }} style={{ color: '#488dff', fontSize: '18px', float: 'right', marginTop: '2px' }}
                    />
                    <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><InsertDriveFileIcon style={{ marginBottom: -2.8, marginRight: 5, fontSize: '16px' }} />
                      {(bgvConsentPreview.name.length > 30) ? `... ${bgvConsentPreview.name.substring(10, 60)}` : bgvConsentPreview.name}
                    </h5>
                  </div>
                  :
                  <div style={{ width: '100%', marginTop: 5 }}>
                    <label htmlFor="bgvConsentFile">
                      <StyledInput
                        accept="file/*"
                        id="bgvConsentFile"
                        type="file"
                        onChange={(e) => pickFile(e, "bgv")}
                      />
                      <div className={'c-card2'} style={{ backgroundColor: 'transparent', padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '1px dashed #488dff', textAlign: 'center' }}>
                        <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} /> Add BGV Consent Form</h5>
                      </div>
                    </label>
                  </div>}

                {thumbPreview ?
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '0.1px solid #488dff' }}>
                    <HighlightOffTwoToneIcon onClick={() => { handleDeleteRefFile("thumb"); setThumbFile(null); setThumbPreview(null); }} style={{ color: '#c33b3b', fontSize: '18px', float: 'right' }} />
                    <h5 className='c-label2' style={{ fontWeight: 'normal', fontSize: 15 }}>Thumb</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <RemoveRedEyeTwoToneIcon
                      onClick={() => {
                        setDocumentModel(true)
                        setDocument({ name: "Thumb Preview", document: thumbPreview?.data?.location ? thumbPreview?.data?.location : '' });
                      }} style={{ color: '#488dff', fontSize: '18px', float: 'right', marginTop: '2px' }}
                    />
                    <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><InsertDriveFileIcon style={{ marginBottom: -2.8, marginRight: 5, fontSize: '16px' }} />
                      {(thumbPreview.name.length > 30) ? `... ${thumbPreview.name.substring(10, 60)}` : thumbPreview.name}
                    </h5>
                  </div>
                  :
                  <div style={{ width: '100%', marginTop: 5 }}>
                    <label htmlFor="thumbFile">
                      <StyledInput
                        accept="file/*"
                        id="thumbFile"
                        type="file"
                        onChange={(e) => pickFile(e, "thumb")}
                      />
                      <div className={'c-card2'} style={{ backgroundColor: 'transparent', padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '1px dashed #488dff', textAlign: 'center' }}>
                        <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} /> Add Thumb File</h5>
                      </div>
                    </label>
                  </div>}

                {aadharPreview ?
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '0.1px solid #488dff' }}>
                    <HighlightOffTwoToneIcon onClick={() => { handleDeleteRefFile("aadhar"); setAadharFile(null); setAadharPreview(null); }} style={{ color: '#c33b3b', fontSize: '18px', float: 'right' }} />
                    <h5 className='c-label2' style={{ fontWeight: 'normal', fontSize: 15 }}>Aadhar Card</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <RemoveRedEyeTwoToneIcon
                      onClick={() => {
                        setDocumentModel(true)
                        setDocument({ name: "Aadhar Card", document: aadharPreview?.data?.uri ? aadharPreview?.data?.uri : aadharPreview?.url });
                      }} style={{ color: '#488dff', fontSize: '18px', float: 'right', marginTop: '2px' }} />
                    <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><InsertDriveFileIcon style={{ marginBottom: -2.8, marginRight: 5, fontSize: '16px' }} />
                      {(aadharPreview.name.length > 30) ? `... ${aadharPreview.name.substring(10, 60)}` : aadharPreview.name}
                    </h5>
                  </div>
                  :
                  <div style={{ width: '100%', marginTop: 5 }}>
                    <label htmlFor="aadharFile">
                      <StyledInput
                        accept="file/*"
                        id="aadharFile"
                        type="file"
                        onChange={(e) => pickFile(e, "aadhar")}
                      />
                      <div className={'c-card2'} style={{ backgroundColor: 'transparent', padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '1px dashed #488dff', textAlign: 'center' }}>
                        <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} /> Add Aadhar Card</h5>
                      </div>
                    </label>
                  </div>
                }

                {panCardPreview ?
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '0.1px solid #488dff' }}>
                    <HighlightOffTwoToneIcon onClick={() => { handleDeleteRefFile("pan"); setPanCardFile(null); setPanCardPreview(null); }} style={{ color: '#c33b3b', fontSize: '18px', float: 'right' }} />
                    <h5 className='c-label2' style={{ fontWeight: 'normal', fontSize: 15 }}>Pan Card</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <RemoveRedEyeTwoToneIcon
                      onClick={() => {
                        setDocumentModel(true)
                        setDocument({ name: "Pan Card", document: panCardPreview?.data?.uri ? panCardPreview?.data?.uri : panCardPreview?.url });
                      }} style={{ color: '#488dff', fontSize: '18px', float: 'right', marginTop: '2px' }} />
                    <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><InsertDriveFileIcon style={{ marginBottom: -2.8, marginRight: 5, fontSize: '16px' }} />
                      {(panCardPreview.name.length > 30) ? `... ${panCardPreview.name.substring(10, 60)}` : panCardPreview.name}
                    </h5>
                  </div>
                  :
                  <div style={{ width: '100%', marginTop: 5 }}>
                    <label htmlFor="panCardFile">
                      <StyledInput
                        accept="file/*"
                        id="panCardFile"
                        type="file"
                        onChange={(e) => pickFile(e, "pan")}
                      />
                      <div className={'c-card2'} style={{ backgroundColor: 'transparent', padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '1px dashed #488dff', textAlign: 'center' }}>
                        <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} /> Add Pan Card</h5>
                      </div>
                    </label>
                  </div>}

                {passbookPreview ?
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '0.1px solid #488dff' }}>
                    <HighlightOffTwoToneIcon onClick={() => { handleDeleteRefFile("passbook"); setPassbookFile(null); setPassbookPreview(null); }} style={{ color: '#c33b3b', fontSize: '18px', float: 'right' }} />
                    <h5 className='c-label2' style={{ fontWeight: 'normal', fontSize: 15 }}>Passbook</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <RemoveRedEyeTwoToneIcon
                      onClick={() => {
                        setDocumentModel(true)
                        setDocument({ name: "Passbook", document: passbookPreview?.data?.uri ? passbookPreview?.data?.uri : passbookPreview?.url });
                      }} style={{ color: '#488dff', fontSize: '18px', float: 'right', marginTop: '2px' }} />
                    <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><InsertDriveFileIcon style={{ marginBottom: -2.8, marginRight: 5, fontSize: '16px' }} />
                      {(passbookPreview.name.length > 30) ? `... ${passbookPreview.name.substring(10, 60)}` : passbookPreview.name}
                    </h5>
                  </div>
                  :
                  <div style={{ width: '100%', marginTop: 5 }}>
                    <label htmlFor="passbookFile">
                      <StyledInput
                        accept="file/*"
                        id="passbookFile"
                        type="file"
                        onChange={(e) => pickFile(e, "passbook")}
                      />
                      <div className={'c-card2'} style={{ backgroundColor: 'transparent', padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '1px dashed #488dff', textAlign: 'center' }}>
                        <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} /> Add Passbook</h5>
                      </div>
                    </label>
                  </div>}

                {pvcPreview ?
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '0.1px solid #488dff' }}>
                    <HighlightOffTwoToneIcon onClick={() => { handleDeleteRefFile("pvc"); setPvcFile(null); setPvcPreview(null); }} style={{ color: '#c33b3b', fontSize: '18px', float: 'right' }} />
                    <h5 className='c-label2' style={{ fontWeight: 'normal', fontSize: 15 }}>PVC (Police Verification Ceriticate)</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <RemoveRedEyeTwoToneIcon
                      onClick={() => {
                        setDocumentModel(true)
                        setDocument({ name: "PVC (Police Verification Ceriticate)", document: pvcPreview?.data?.uri ? pvcPreview?.data?.uri : pvcPreview?.url });
                      }} style={{ color: '#488dff', fontSize: '18px', float: 'right', marginTop: '2px' }} />
                    <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><InsertDriveFileIcon style={{ marginBottom: -2.8, marginRight: 5, fontSize: '16px' }} />
                      {(pvcPreview.name.length > 30) ? `... ${pvcPreview.name.substring(10, 60)}` : pvcPreview.name}
                    </h5>
                  </div>
                  :
                  <div style={{ width: '100%', marginTop: 5 }}>
                    <label htmlFor="pvcFile">
                      <StyledInput
                        accept="file/*"
                        id="pvcFile"
                        type="file"
                        onChange={(e) => pickFile(e, "pvc")}
                      />
                      <div className={'c-card2'} style={{ backgroundColor: 'transparent', padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '1px dashed #488dff', textAlign: 'center' }}>
                        <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} /> Add PVC<br />(Police Verification Ceriticate)</h5>
                      </div>
                    </label>
                  </div>}

                {bvcPreview ?
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '0.1px solid #488dff' }}>
                    <HighlightOffTwoToneIcon onClick={() => { handleDeleteRefFile("bvc"); setBvcFile(null); setBvcPreview(null); }} style={{ color: '#c33b3b', fontSize: '18px', float: 'right' }} />
                    <h5 className='c-label2' style={{ fontWeight: 'normal', fontSize: 15 }}>BVC<br />(Background Verification Ceriticate)</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <RemoveRedEyeTwoToneIcon
                      onClick={() => {
                        setDocumentModel(true)
                        setDocument({ name: "BVC (Background Verification Ceriticate)", document: bvcPreview?.data?.uri ? bvcPreview?.data?.uri : bvcPreview?.url });
                      }} style={{ color: '#488dff', fontSize: '18px', float: 'right', marginTop: '2px' }} />
                    <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><InsertDriveFileIcon style={{ marginBottom: -2.8, marginRight: 5, fontSize: '16px' }} />
                      {(bvcPreview.name.length > 30) ? `... ${bvcPreview.name.substring(10, 60)}` : bvcPreview.name}
                    </h5>
                  </div>
                  :
                  <div style={{ width: '100%', marginTop: 5 }}>
                    <label htmlFor="bvcFile">
                      <StyledInput
                        accept="file/*"
                        id="bvcFile"
                        type="file"
                        onChange={(e) => pickFile(e, "bvc")}
                      />
                      <div className={'c-card2'} style={{ backgroundColor: 'transparent', padding: 15, paddingTop: 10, paddingBottom: 10, marginBottom: 15, border: '1px dashed #488dff', textAlign: 'center' }}>
                        <h5 style={{ fontWeight: 'normal', color: '#488dff', fontSize: 14 }}><AddCircleOutlineOutlinedIcon style={{ marginBottom: -2.8, fontSize: '16px' }} /> Add BVC<br />(Background Verification Ceriticate)</h5>
                      </div>
                    </label>
                  </div>}

              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Box>
      {<DialogClientForm open={open[3]} title={'Buyer'} onClose={closeDialog} onCancel={cancelDialog} selectedData={selectedClientHandler}></DialogClientForm>}
      {/* </CardContent> */}
      <Modal
        open={documentModel}
        onClose={(event: any, reason: any) => {
          if (reason !== 'backdropClick') {
            setDocumentModel(false)
          }
        }}
      >
        <Box sx={style}>
          <Grid container >
            <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
              <div style={{ float: 'right', marginTop: -7, marginRight: -5 }}>
                <IconButton size='small' onClick={() => setDocumentModel(false)} style={{ marginRight: -5 }} >
                  <HighlightOffOutlinedIcon color="error" />
                </IconButton>
              </div>
              <h3 style={{ marginTop: -2 }}>{document?.name}</h3>
              {/* {JSON.stringify(selectedBank)} */}
            </Grid>

          </Grid>
          <img src={document?.document} style={{ marginTop: 5, width: '100%', height: 'auto', padding: 5, borderRadius: 15, border: '.5px solid #e9ecf1', objectFit: 'cover' }} />
        </Box>
      </Modal>
    </FormProvider>
  );
}

export default EmployeeForm;
